import type { PartialMessages } from './es';

// Deutsch: die gesamte Oberfläche des Dashboards. Jeder Text des Spanischen (der Quelle) ist hier vorhanden;
// ein Test (complete.test.ts) prüft, dass nichts fehlt und die Zahlen an denselben Stellen stehen.
export const de: PartialMessages = {
  shell: {
    product: 'Barrierefreiheit, Schritt für Schritt',
    headline: 'Eine bessere Website beginnt damit, zu wissen, was sich verbessern lässt.',
    intro:
      'Analysieren Sie Ihre Websites, finden Sie Barrieren und organisieren Sie die Arbeit Ihres Teams an einem Ort.',
    connect: 'Verbinden Sie Ihre Website',
    connectHint: 'Fügen Sie Ihre Domain hinzu und wählen Sie ihr Regelwerk.',
    understand: 'Verstehen Sie die Barrieren',
    understandHint: 'Sehen Sie Probleme, Prioritäten und wie Sie sie beheben.',
    improve: 'Kommen Sie gemeinsam voran',
    improveHint: 'Prüfen Sie die Ergebnisse und halten Sie Ihre Entscheidungen fest.',
    note: 'Die Punktewerte sind orientierend. Die automatische Analyse sollte durch eine manuelle Prüfung ergänzt werden, um die Einhaltung der Barrierefreiheitsanforderungen zu bewerten.',
  },
  app: {
    name: 'SiteNorma',
    home: 'SiteNorma, Startseite des Dashboards',
    website: 'SiteNorma, Startseite der Website',
    skip: 'Zum Inhalt springen',
    language: 'Sprache',
    userMenu: 'Benutzermenü',
    signOut: 'Abmelden',
    loading: 'Wird geladen …',
    retry: 'Erneut versuchen',
    newTab: 'öffnet sich in einem neuen Tab',
  },
  password: {
    show: 'Passwort anzeigen',
    hide: 'Passwort verbergen',
    rules: {
      min: 'Mindestens {{min}} Zeichen',
      max: 'Höchstens {{max}} Zeichen',
      met: 'erfüllt',
      unmet: 'nicht erfüllt',
    },
    errors: {
      min: 'Das Passwort braucht mindestens {{min}} Zeichen.',
      max: 'Das Passwort darf nicht länger als {{max}} Zeichen sein.',
    },
    nowVisible: 'Das Passwort ist auf dem Bildschirm sichtbar.',
    nowHidden: 'Das Passwort ist verborgen.',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    text: 'Diese Adresse existiert nicht oder hat sich geändert.',
    home: 'Zum Dashboard',
  },
  form: {
    requiredNote: 'Mit * markierte Felder sind Pflichtfelder.',
  },
  errors: {
    title: 'Etwas ist schiefgelaufen',
    generic: 'Wir konnten die Anfrage nicht abschließen. Bitte versuchen Sie es erneut.',
    required: 'Füllen Sie dieses Feld aus.',
    tooShort: 'Geben Sie mindestens {{min}} Zeichen ein.',
    invalidCredentials: 'Die E-Mail-Adresse oder das Passwort ist nicht korrekt.',
    userExists:
      'Mit dieser E-Mail-Adresse gibt es bereits ein Konto. Melden Sie sich an oder setzen Sie Ihr Passwort zurück.',
  },
  forms: {
    email: {
      required: 'Geben Sie Ihre E-Mail-Adresse ein.',
      invalid: 'Geben Sie eine gültige E-Mail-Adresse ein.',
    },
    password: {
      required: 'Geben Sie Ihr Passwort ein.',
    },
    privacy: {
      required: 'Sie müssen das Datenschutz-Kontrollkästchen aktivieren, um das Konto zu erstellen.',
    },
    verifyLink: 'Dieser Link ist ungültig oder abgelaufen. Fordern Sie eine neue Bestätigungs-E-Mail an.',
    limit: {
      before: 'Zu viele Versuche. Sie können es erneut versuchen in',
      seconds_one: '{{count}} Sekunde.',
      seconds_other: '{{count}} Sekunden.',
      over: 'Sie können es jetzt erneut versuchen.',
      unknown: 'Zu viele Versuche. Warten Sie einen Moment und versuchen Sie es erneut.',
    },
  },
  google: {
    or: 'oder',
    login: 'Weiter mit Google',
    signup: 'Mit Google registrieren',
    connecting: 'Verbindung mit Google wird hergestellt …',
    errors: {
      cancelled:
        'Sie haben die Anmeldung mit Google abgebrochen. Sie können es erneut versuchen oder Ihre E-Mail-Adresse und Ihr Passwort verwenden.',
      noAccount: 'Zu diesem Google-Konto gibt es kein SiteNorma-Konto. Legen Sie zuerst eines an.',
      notLinked:
        'Es gibt bereits ein Konto mit der E-Mail-Adresse Ihres Google-Kontos, aber es ist noch nicht bestätigt. Bestätigen Sie es mit dem Link, den wir Ihnen geschickt haben, oder melden Sie sich mit Ihrem Passwort an.',
      notVerified:
        'Google hat diese E-Mail-Adresse nicht bestätigt, daher können wir sie nicht für Ihr Konto verwenden.',
      failed:
        'Wir konnten nicht mit Google fortfahren. Versuchen Sie es erneut oder verwenden Sie Ihre E-Mail-Adresse und Ihr Passwort.',
    },
  },
  login: {
    title: 'Anmelden',
    subtitle: 'Melden Sie sich mit E-Mail und Passwort bei Ihrem Konto an.',
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    submit: 'Anmelden',
    forgot: 'Passwort vergessen?',
    noAccount: 'Sie haben noch kein Konto?',
    signup: 'Konto erstellen',
    submitting: 'Anmeldung…',
  },
  signup: {
    title: 'Erstellen Sie Ihr SiteNorma-Konto',
    benefit: 'Verwalten Sie Ihre Barrierefreiheitsanalysen und sehen Sie ihre Ergebnisse an einem Ort.',
    privacy: {
      label:
        'Ich habe die <privacy>Datenschutzerklärung</privacy> und die <terms>Nutzungsbedingungen</terms> gelesen und akzeptiere sie. Wir verwenden Ihre E-Mail-Adresse, um Ihr Konto zu verwalten und Ihnen Mitteilungen zum Service zu senden.',
      language: 'Diese Dokumente sind auf Englisch verfügbar.',
    },
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    verify: 'Um Ihr Konto zu aktivieren, müssen Sie Ihre E-Mail-Adresse bestätigen.',
    submit: 'Konto erstellen',
    submitting: 'Konto wird erstellt …',
    haveAccount: 'Sie haben bereits ein Konto?',
    login: 'Anmelden',
  },
  verify: {
    title: 'Bestätigen Sie Ihre E-Mail-Adresse',
    sent: 'Wir haben eine Bestätigungs-E-Mail an {{email}} gesendet. Öffnen Sie den Link, um Ihr Konto zu aktivieren. Der Link läuft in einer Stunde ab.',
    notSent:
      'Ihr Konto wurde erstellt, aber wir konnten die Bestätigungs-E-Mail an {{email}} nicht senden. Es muss noch bestätigt werden: Versuchen Sie es erneut, Sie müssen sich nicht noch einmal registrieren.',
    pendingLogin:
      'Um sich anzumelden, müssen Sie Ihre E-Mail-Adresse bestätigen. Wir haben einen Link an {{email}} gesendet; wenn Sie ihn nicht mehr finden, können Sie einen neuen anfordern.',
    spam: 'Wenn Sie die Nachricht nicht finden, prüfen Sie Ihren Spam-Ordner und ob die Adresse stimmt.',
    resend: 'Bestätigungs-E-Mail erneut senden',
    resending: 'Wird gesendet…',
    resent: 'Wir haben eine weitere Bestätigungs-E-Mail an {{email}} gesendet.',
    wait: 'Sie können eine weitere E-Mail anfordern in',
    over: 'Sie können die Bestätigungs-E-Mail jetzt erneut senden.',
    correct: 'E-Mail-Adresse korrigieren',
    newEmail: 'Richtige E-Mail-Adresse',
    correctHint:
      'Wir senden den Link an die neue Adresse. Links an die alte Adresse funktionieren nicht mehr, und Ihr Konto bleibt offen, bis Sie die neue bestätigen.',
    correctSubmit: 'Speichern und Bestätigung senden',
    correctSubmitting: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    corrected:
      'Wir haben eine Bestätigungs-E-Mail an {{email}} gesendet. Links an die frühere Adresse funktionieren nicht mehr.',
    sendFailed:
      'Wir konnten die Bestätigungs-E-Mail nicht senden. Ihr Konto bleibt offen: Versuchen Sie es erneut.',
    credentials: 'Wir konnten das Konto nicht prüfen. Melden Sie sich erneut an, um fortzufahren.',
    back: 'Zurück zur Anmeldung',
    done: {
      okTitle: 'E-Mail-Adresse bestätigt',
      ok: 'Ihre E-Mail-Adresse wurde bestätigt. Sie können sich jetzt bei SiteNorma anmelden.',
      alreadyTitle: 'Konto bereits bestätigt',
      already: 'Ihr Konto ist bereits bestätigt.',
      invalidTitle: 'Link ungültig',
      invalid: 'Dieser Link ist ungültig oder abgelaufen. Fordern Sie eine neue Bestätigungs-E-Mail an.',
      noneTitle: 'Bestätigen Sie Ihre E-Mail-Adresse',
      none: 'Um Ihre E-Mail-Adresse zu bestätigen, öffnen Sie den Link in der Nachricht, die wir Ihnen gesendet haben. Falls Sie sie nicht haben, können Sie eine neue anfordern.',
      login: 'Anmelden',
      request: 'Neue E-Mail anfordern',
    },
    request: {
      title: 'Neue Bestätigungs-E-Mail anfordern',
      intro: 'Geben Sie die E-Mail-Adresse ein, mit der Sie Ihr Konto erstellt haben.',
      email: 'E-Mail-Adresse',
      submit: 'Neue E-Mail anfordern',
      submitting: 'Wird angefordert…',
      sent: 'Wenn es ein Konto mit dieser E-Mail-Adresse gibt, das noch bestätigt werden muss, erhalten Sie einen neuen Link. Prüfen Sie auch Ihren Spam-Ordner.',
    },
  },
  forgot: {
    title: 'Zugang zu Ihrem Konto wiederherstellen',
    sentTitle: 'Prüfen Sie Ihre E-Mails',
    intro:
      'Geben Sie die E-Mail-Adresse Ihres Kontos ein, um einen Link zum Zurücksetzen Ihres Passworts anzufordern.',
    email: 'E-Mail-Adresse',
    submit: 'Link anfordern',
    sent: 'Wenn ein Konto mit dieser E-Mail-Adresse verknüpft ist, erhalten Sie einen Link zum Zurücksetzen Ihres Passworts. Prüfen Sie auch Ihren Spam-Ordner.',
    back: 'Zurück zur Anmeldung',
    submitting: 'Link wird angefordert…',
  },
  reset: {
    title: 'Neues Passwort festlegen',
    doneTitle: 'Passwort aktualisiert',
    password: 'Neues Passwort',
    submit: 'Passwort speichern',
    done: 'Ihr Passwort wurde erfolgreich aktualisiert.',
    invalid:
      'Dieser Link ist ungültig, abgelaufen oder wurde bereits verwendet. Fordern Sie einen neuen an, um Ihr Passwort zurückzusetzen.',
    login: 'Anmelden',
    submitting: 'Wird gespeichert…',
    another: 'Neuen Link anfordern',
    pending:
      'Um sich anzumelden, müssen Sie Ihre E-Mail-Adresse noch bestätigen. Bei der Anmeldung helfen wir Ihnen dabei.',
  },
  organization: {
    title: 'Erstellen Sie Ihre Organisation',
    intro: 'Ihre Organisation fasst Ihre Websites und die Personen zusammen, mit denen Sie daran arbeiten.',
    name: 'Name der Organisation',
    nameHint: 'Zum Beispiel der Name Ihres Unternehmens oder Ihrer Agentur.',
    submit: 'Organisation erstellen',
    nav: 'Organisation',
    navMembers: 'Personen',
    navBilling: 'Tarif und Abrechnung',
  },
  billing: {
    title: 'Tarif und Abrechnung',
    loadFailed: 'Der Tarif konnte nicht geladen werden. Versuchen Sie es erneut.',
    myPlan: 'Mein Tarif',
    planName: 'Tarif {{plan}}',
    includes: 'Enthalten',
    pagesLimit: 'Analysierte Seiten pro Monat',
    pagesPerMonth_one: '{{count}} Seite',
    pagesPerMonth_other: '{{count}} Seiten',
    pagesUnlimited: 'Unbegrenzt',
    wpLimit: 'Mit WordPress verknüpfte Websites',
    wpSites_one: 'Bis zu {{count}} Website',
    wpSites_other: 'Bis zu {{count}} Websites',
    wpUnlimited: 'Unbegrenzt',
    selectPages: 'Manuelle Seitenauswahl',
    selectPagesYes: 'Enthalten',
    selectPagesNo: 'Nicht enthalten',
    seeOtherPlans: 'Andere Tarife ansehen',
    usageOfMonth: 'Nutzung im {{month}}',
    pagesAnalysed_one: '{{count}} Seite aus dem Kontingent dieses Monats',
    pagesAnalysed_other: '{{count}} Seiten aus dem Kontingent dieses Monats',
    pagesUsedOf: '{{used}} von {{limit}} Seiten aus dem Kontingent dieses Monats',
    pagesAvailable_one: '{{count}} Seite verfügbar',
    pagesAvailable_other: '{{count}} Seiten verfügbar',
    monthlyQuotaUnlimited: 'Monatliches Kontingent: unbegrenzt.',
    usageLabel: 'Genutzte Seiten des monatlichen Kontingents',
    usageHint:
      'Zählt die Seiten aller Ihrer Analysen in diesem Monat: jede zählt mit. Unter „Ihre Websites“ zählt „Analysierte Seiten“ nur die letzte Analyse jeder Website.',
    usageReserved_one: '{{count}} Seite für Analysen in der Warteschlange oder laufend reserviert.',
    usageReserved_other: '{{count}} Seiten für Analysen in der Warteschlange oder laufend reserviert.',
    quotaResets: 'Der Zähler wird am {{date}} zurückgesetzt.',
    managementTitle: 'Verwaltung und Abrechnung',
    managementFree:
      'Sehen Sie sich andere Tarife an oder kontaktieren Sie unser Team, um Ihr Abonnement zu verwalten.',
    managementPaid:
      'Sehen Sie sich andere Tarife an oder kontaktieren Sie unser Team, um Ihr Abonnement zu verwalten.',
    readOnly:
      'Sie können Tarif und Nutzung einsehen. Zum Ändern oder zur Verwaltung des Abonnements bitten Sie eine Eigentümerin, einen Eigentümer oder eine Administration der Organisation.',
    seePlans: 'Tarife ansehen',
    contactSupport: 'Support kontaktieren',
    assigned:
      'Ihren Tarif verwaltet unser Team, ein Kauf ändert ihn nicht. Wenn Sie ihn ändern möchten, schreiben Sie uns.',
    purchase: {
      title: 'Wählen Sie Ihren Tarif',
      intro:
        'Sie zahlen für die Seiten, die wir jeden Monat analysieren, Desktop und Mobil inklusive. Die Preise verstehen sich ohne MwSt.',
      period: 'Abrechnungszeitraum',
      month: 'Monatlich',
      year: 'Jährlich',
      yearHint: '2 Monate gratis',
      perMonth: '{{price}} pro Monat',
      perYear: '{{price}} pro Jahr',
      equivalent: 'Entspricht {{price}} pro Monat',
      buy: '{{plan}} abonnieren',
      redirecting: 'Sichere Zahlung wird geöffnet …',
      secure:
        'Die Zahlung erfolgt auf einer sicheren Stripe-Seite: SiteNorma sieht und speichert Ihre Kartendaten nicht. Sie können jederzeit kündigen; der Tarif bleibt bis zum Ende des bezahlten Zeitraums aktiv.',
      custom: 'Mehr Volumen nötig? Sprechen Sie uns an',
      errors: {
        failed: 'Wir konnten die Zahlung nicht öffnen. Versuchen Sie es erneut.',
        'suscripcion-activa':
          'Sie haben bereits ein Abonnement. Um den Tarif zu wechseln, nutzen Sie „Abonnement verwalten“.',
        'plan-asignado': 'Ihren Tarif verwaltet unser Team, ein Kauf ändert ihn nicht.',
        limite: 'Sie haben es zu oft versucht. Warten Sie kurz und versuchen Sie es erneut.',
        permisos: 'Nur Eigentümer und Administratoren der Organisation können einen Tarif abonnieren.',
      },
    },
    subscription: {
      title: 'Ihr Abonnement',
      line: 'Tarif {{plan}}, {{period}} abgerechnet: {{price}} (ohne MwSt.).',
      month: 'monatlich',
      year: 'jährlich',
      renews: 'Es verlängert sich am {{date}}.',
      cancels:
        'Das Abonnement ist gekündigt. Sie behalten den Tarif {{plan}} bis zum {{date}}; danach wechseln Sie ohne Datenverlust zurück zum Tarif Kostenlos.',
      pastDue:
        'Wir konnten die letzte Zahlung nicht einziehen. Aktualisieren Sie Ihre Zahlungsmethode, damit Sie den Tarif nicht verlieren.',
      manage: 'Abonnement verwalten',
      manageHint:
        'Wechseln Sie den Tarif, aktualisieren Sie Karte oder Rechnungsdaten oder kündigen Sie das Abonnement. Es öffnet sich eine sichere Stripe-Seite.',
      portalFailed: 'Wir konnten die Abonnementverwaltung nicht öffnen. Versuchen Sie es erneut.',
    },
    return: {
      paid: 'Zahlung erhalten. Ihr Tarif {{plan}} ist jetzt aktiv.',
      confirming: 'Wir bestätigen die Zahlung bei Stripe. Das kann einige Sekunden dauern.',
      cancelled: 'Es wurde nichts abgebucht. Sie können jederzeit einen Tarif wählen.',
    },
    summaries: {
      gratis: 'Für eine erste Prüfung Ihrer wichtigsten Seiten.',
      pro: 'Für Organisationen, die Anforderungen erfüllen und dokumentieren müssen.',
      agencia: 'Für Agenturen, die die Websites ihrer Kundinnen und Kunden betreuen.',
      'a-medida': 'Für große Volumina und Organisationen mit eigenen Anforderungen.',
      infinita: 'Voller Zugang zu SiteNorma ohne Nutzungslimits.',
    },
    features: {
      gratis: [
        'Analyse einer Seite und Schnellanalyse',
        'Automatische Barrierefreiheit nach WCAG 2.2 A und AA, auf Desktop und Mobil',
      ],
      pro: [
        'Unbegrenzte Websites und Nutzerinnen und Nutzer',
        'Vollständige Analysen auf bestätigten Websites',
        'Regulatorische Anforderungen und geführte manuelle Prüfung',
        'PDF-Berichte',
      ],
      agencia: ['Alles aus Pro', 'Mehr Kapazität für Teams, die mehrere Websites betreuen'],
      'a-medida': ['Alles aus Agentur', 'Bedingungen, die an Ihre Organisation angepasst sind'],
      infinita: [],
    },
  },
  home: {
    figures: {
      sites: 'Websites',
      verified_one: '{{count}} verifiziert',
      verified_other: '{{count}} verifiziert',
      problems: 'Erkannte Problemtypen',
      problemsHelp: 'Was Problemtypen sind',
      problemsHelpText:
        'Ein Problemtyp ist eine Art von Mangel (zum Beispiel Bilder ohne Alternativtext). Betroffene Elemente sind die konkreten Stellen, an denen er auftritt. Die Summe zählt die letzte Analyse jeder Website, ohne Verworfenes.',
      elements_one: '{{count}} betroffenes Element',
      elements_other: '{{count}} betroffene Elemente',
      elementsCapped_one: '{{count}}+ betroffenes Element',
      elementsCapped_other: '{{count}}+ betroffene Elemente',
      problemsHelpCapped:
        'Das „+“ bedeutet, dass die Analyse bei einer Prüfung aufgehört hat, Elemente zu zählen: Die tatsächliche Summe kann höher sein.',
      global_one: '{{count}} global',
      global_other: '{{count}} global',
      none: 'Noch keine Analyse',
      pages: 'Analysierte Seiten',
      pagesHint: 'Nur die letzte Analyse jeder Website, nicht die Nutzung des Monats',
      pagesHintSome: 'Nur die letzte von {{analysed}} von {{total}} Websites, nicht die Nutzung des Monats',
    },
    card: {
      pending: 'Analyse ausstehend',
      never: 'Bereiten Sie die erste Analyse vor, um die Ergebnisse zu sehen.',
      requested: 'Angefordert am {{date}}',
      attempt: 'Letzter Versuch: {{date}}',
      lastAnalysis: 'Letzte Analyse: {{date}}',
      lastCompleted: 'Letzte abgeschlossene Analyse: {{date}}',
      estimate: 'Automatische Schätzung:',
      noEstimate: 'Noch keine Schätzung',
      estimateHelp: 'Was die automatische Schätzung bedeutet',
      estimateHelpText:
        'Dies ist eine automatische Schätzung bis 100. Sie ist weder ein Prozentsatz der Einhaltung noch die rechtliche Konformität: Automatische Tests erkennen nur einen Teil der Barrieren.',
      estimateMethod: 'Wie sie berechnet wird',
      deltaUp_one: 'Um {{count}} Punkt besser als bei der vorherigen Analyse.',
      deltaUp_other: 'Um {{count}} Punkte besser als bei der vorherigen Analyse.',
      deltaDown_one: 'Um {{count}} Punkt schlechter als bei der vorherigen Analyse.',
      deltaDown_other: 'Um {{count}} Punkte schlechter als bei der vorherigen Analyse.',
      problems_one: '{{count}} Problemtyp',
      problems_other: '{{count}} Problemtypen',
      priority: {
        alta_one: '{{count}} mit hoher Priorität',
        alta_other: '{{count}} mit hoher Priorität',
        media_one: '{{count}} mit mittlerer Priorität',
        media_other: '{{count}} mit mittlerer Priorität',
        baja_one: '{{count}} mit niedriger Priorität',
        baja_other: '{{count}} mit niedriger Priorität',
      },
      notAnalysed_one: '{{count}} Seite konnte nicht analysiert werden.',
      notAnalysed_other: '{{count}} Seiten konnten nicht analysiert werden.',
      ownership: {
        verified: 'Inhaberschaft verifiziert',
        unverified: 'Inhaberschaft nicht verifiziert',
        checking: 'Inhaberschaft wird geprüft',
        failed: 'Inhaberschaft konnte nicht verifiziert werden',
      },
      actions: {
        prepare: 'Meine Website analysieren',
        results: 'Ergebnisse ansehen',
        progress: 'Analyse ansehen',
        retry: 'Analyse wiederholen',
        open: 'Website öffnen',
      },
    },
    subtitle: 'Ein Ort, um die Barrierefreiheit Ihrer Websites zu prüfen und zu verbessern.',
    listTitle: 'Alle Websites',
    search: 'Nach Name oder Domain suchen',
    results: 'Gefundene Websites: {{count}}',
    noResults:
      'Keine passenden Websites. Versuchen Sie es mit einem anderen Namen oder einer anderen Domain.',
    title: 'Ihre Websites',
    organization: 'Organisation: {{name}} · Ihre Rolle: {{role}}',
    empty: 'Sie haben noch keine Website hinzugefügt.',
    emptyHint:
      'Fügen Sie Ihre erste Website hinzu und beginnen Sie mit einer Schnellanalyse. Verifizieren Sie ihre Inhaberschaft, um vollständige Analysen durchzuführen.',
    emptyReadOnly: 'Sobald jemand aus Ihrer Organisation eine Website hinzufügt, sehen Sie sie hier.',
    add: 'Website hinzufügen',
    roles: {
      owner: 'Inhaber',
      admin: 'Administrator',
      editor: 'Editor',
      viewer: 'Leser',
    },
  },
  sites: {
    status: {
      verified: 'Inhaberschaft verifiziert',
      unverified: 'Inhaberschaft nicht verifiziert',
      checking: 'Inhaberschaft wird geprüft',
      failed: 'Inhaberschaft konnte nicht verifiziert werden',
    },
    profiles: {
      eaa: 'Privater Dienst (Europäischer Rechtsakt zur Barrierefreiheit)',
      'sector-publico': 'Öffentlicher Sektor',
      voluntario: 'Freiwillig',
      'sin-definir': 'Nicht festgelegt',
    },
    profileHints: {
      eaa: 'Für Unternehmen, die Verbrauchern vom Gesetz erfasste Dienste anbieten (E-Commerce, Banken, Verkehr …). Ob es für Sie gilt, hängt von Ihrer Tätigkeit und Größe ab. Referenz: spanisches Gesetz 11/2023.',
      'sector-publico':
        'Für öffentliche Verwaltungen und Einrichtungen des öffentlichen Sektors. Referenz: Königliches Dekret 1112/2018.',
      voluntario:
        'Für Websites ohne besondere rechtliche Pflicht: WCAG 2.2 AA dient als technische Referenz.',
    },
    standards: {
      'EN301549-4.1.1': 'EN 301 549 v4.1.1 · WCAG 2.2 AA',
      'EN301549-3.2.1': 'EN 301 549 v3.2.1 · WCAG 2.1 AA',
      'WCAG22-AA': 'WCAG 2.2 AA',
      'WCAG21-AA': 'WCAG 2.1 AA',
    },
  },
  newSite: {
    title: 'Fügen Sie Ihre Website hinzu',
    intro: 'Geben Sie die Adresse Ihrer Website ein. Danach können Sie die Barrierefreiheitsanalyse starten.',
    url: 'Adresse der Website',
    urlHint:
      'Geben Sie die Adresse der Seite ein, die Sie zuerst analysieren möchten. Zum Beispiel https://www.ihrewebsite.de',
    name: 'Name der Website (optional)',
    nameHint: 'Wenn Sie das Feld leer lassen, verwenden wir die Domain der Website.',
    normalized: 'Adresse, die gespeichert wird: {{url}}',
    existing: 'Sie haben bereits eine Website mit dieser Adresse: „{{name}}“.',
    open: 'Website öffnen',
    submit: 'Website hinzufügen',
    submitting: 'Website wird hinzugefügt …',
    cancel: 'Zurück zu Ihren Websites',
    errors: {
      url: 'Geben Sie eine gültige Webadresse ein, zum Beispiel https://www.ihrewebsite.de',
      duplicada: 'Diese Website gibt es in Ihrer Organisation bereits.',
      permiso: 'Ihre Rolle erlaubt es nicht, Websites hinzuzufügen.',
    },
  },
  account: {
    menuProfile: 'Mein Profil',
    menuSecurity: 'Sicherheit',
    planLabel: 'Tarif {{plan}}',
    nav: 'Ihr Konto',
    scope:
      'Diese Einstellungen sind persönlich: Sie hängen weder von einer Website noch von Ihrer Organisation ab. Die Einstellungen jeder Website finden Sie in der Website selbst unter „Einstellungen“. Tarif und Abrechnung finden Sie unter Organisation → Tarif und Abrechnung.',
    profile: {
      title: 'Mein Profil',
      name: 'Name',
      email: 'E-Mail-Adresse',
      emailHint: 'Mit dieser Adresse melden Sie sich bei SiteNorma an. Sie kann hier nicht geändert werden.',
      save: 'Änderungen speichern',
      saving: 'Wird gespeichert…',
      saved: 'Änderungen gespeichert.',
    },
    security: {
      title: 'Sicherheit',
      intro:
        'Ändern Sie das Passwort, mit dem Sie sich anmelden. Dabei werden Ihre anderen Geräte abgemeldet; diese Sitzung bleibt bestehen.',
      current: 'Aktuelles Passwort',
      new: 'Neues Passwort',
      submit: 'Passwort ändern',
      submitting: 'Wird geändert…',
      done: 'Ihr Passwort wurde geändert. Ihre anderen Sitzungen wurden beendet.',
      currentWrong: 'Das aktuelle Passwort ist nicht korrekt.',
    },
  },
  seal: {
    tab: 'Siegel für Barrierefreiheit',
    title: 'Siegel für Barrierefreiheit',
    intro:
      'Zeigen Sie auf Ihrer Website, dass Sie die Barrierefreiheitsprüfungen von SiteNorma bestanden haben. Das Siegel ermöglicht es, die Ergebnisse und das Datum der letzten Prüfung einzusehen, ist aber keine WCAG-Zertifizierung.', // claims-ok
    status: {
      inactivo: 'Nicht aktiviert',
      vigente: 'Aktiv',
      caducado: 'Abgelaufen',
      suspendido: 'Ausgesetzt',
    },
    statusHint: {
      inactivo: 'Das Siegel wird auf keiner Website angezeigt.',
      vigente: 'Sie erfüllen die Anforderungen und die letzte Prüfung ist aktuell.',
      caducado:
        'Die letzte vollständige Prüfung ist älter als {{days}} Tage: Führen Sie eine neue vollständige Analyse durch, um es zu erneuern. Bis dahin wird das Siegel als abgelaufen angezeigt.',
      suspendido:
        'Eine Anforderung ist nicht mehr erfüllt: Das Siegel wird als ausgesetzt angezeigt und die öffentliche Seite weist darauf hin.',
    },
    requirements: {
      title: 'Anforderungen prüfen',
      progress: '{{done}} von {{total}} Anforderungen erfüllt',
      recommended: 'Empfohlen (keine Anforderung)',
      met: 'erfüllt',
      pending: 'ausstehend',
      lastAnalysis: 'Letzte vollständige Analyse: {{date}} ({{pages}} Seiten analysiert).',
    },
    criteria: {
      ownership: 'Das Eigentum an der Website ist verifiziert.',
      analysis: 'Es gibt eine aktuelle vollständige Analyse aus den letzten {{days}} Tagen.',
      noHigh: 'Es gibt keine offenen Probleme mit hoher Priorität.',
      manual: 'Alle anwendbaren manuellen Prüfungen sind durchgeführt, ohne Probleme mit hoher Priorität.',
    },
    recommended: {
      statement:
        'Die Website hat eine veröffentlichte Erklärung zur Barrierefreiheit. Sie ist ein eigenes Dokument neben dem Siegel, wir empfehlen sie aber.',
    },
    fix: {
      ownership: 'Website verifizieren',
      analysis: 'Vollständige Analyse durchführen',
      noHigh: 'Probleme ansehen',
      manual: 'Manuelle Prüfungen durchführen',
      statement: 'Erklärung erstellen',
    },
    scope: {
      title: 'Was geprüft wird',
      hint: 'Seiten und Prüfungen, die bestanden werden müssen',
      analysis:
        'Eine vollständige Analyse der Website (bis zu 50 Seiten, auf Desktop und Mobilgerät), mit allen analysierten Seiten abgeschlossen, aus den letzten {{days}} Tagen.',
      checks:
        'Diese Analyse hinterlässt keine offenen Probleme mit hoher Priorität; was das Team begründet verworfen hat, zählt nicht.',
      manual:
        'Alle manuellen Prüfungen, die für die Website gelten, mit erfasster Prüfung und ohne Probleme mit hoher Priorität.',
      not: 'Sie zu bestehen ist nicht dasselbe wie der Nachweis der vollständigen WCAG-Einhaltung: Das Siegel sagt genau das und nichts weiter.',
    },
    activate: {
      title: 'Siegel aktivieren',
      intro:
        'Die Aktivierung erstellt die öffentliche Prüfseite und das Siegel ist bereit für Ihre Website. Es erscheint dort erst, wenn Sie es einbinden (nächster Schritt).',
      button: 'Siegel aktivieren',
      disabled_one: 'Es fehlt {{count}} Anforderung',
      disabled_other: 'Es fehlen {{count}} Anforderungen',
      done: 'Siegel aktiviert. Binden Sie es nun in die Fußzeile Ihrer Website ein.',
      active: 'Das Siegel ist aktiviert.',
    },
    withdraw: 'Siegel zurückziehen',
    withdrawTitle: 'Siegel zurückziehen?',
    withdrawMessage:
      'Das Siegel wird auf Ihrer Website nicht mehr angezeigt und die öffentliche Seite funktioniert nicht mehr.',
    withdrawn: 'Siegel zurückgezogen.',
    notEligible: 'Die Website erfüllt nicht mehr alle Anforderungen.',
    readOnly:
      'Ihre Rolle erlaubt nur, das Siegel anzusehen. Bitten Sie jemanden mit der Rolle Editor oder höher, es zu aktivieren.',
    preview: {
      title: 'Vorschau',
      notReady_one:
        'Es kann noch nicht aktiviert werden: Es fehlt {{count}} Anforderung. So würde es aussehen, sobald sie erfüllt ist.',
      notReady_other:
        'Es kann noch nicht aktiviert werden: Es fehlen {{count}} Anforderungen. So würde es aussehen, sobald sie erfüllt sind.',
      language: 'Sprache',
      detected: '(auf Ihrer Website erkannt)',
      theme: 'Hintergrund der Fußzeile',
      themes: {
        light: 'Hell',
        dark: 'Dunkel',
      },
      size: 'Größe',
      sizes: {
        s: 'Klein',
        m: 'Mittel',
        l: 'Groß',
      },
      states: {
        vigente: 'Aktiv',
        caducado: 'Abgelaufen',
        suspendido: 'Ausgesetzt',
      },
      footer: 'So sieht es in einer Fußzeile aus',
      footerLinks: 'Impressum · Datenschutz · Cookies',
      alt: 'SiteNorma-Siegel für Barrierefreiheit (Vorschau)',
    },
    embed: {
      title: 'In die Fußzeile Ihrer Website einbinden',
      locked: 'Verfügbar, sobald Sie das Siegel aktivieren.',
      wordpress: {
        title: 'WordPress',
        how: 'Öffnen Sie in Ihrem WordPress SiteNorma → Verbindung und aktivieren Sie „Siegel auf meiner Website anzeigen“. Wählen Sie Größe, Sprache und helle oder dunkle Version: Das Plugin setzt es in die Fußzeile und zeigt es nur, solange das Siegel aktiv ist.',
        open: 'Plugin in Ihrem WordPress öffnen',
        none: 'Mit dem SiteNorma-Plugin gelangt das Siegel von selbst in die WordPress-Fußzeile, ohne Code anzufassen.',
        connect: 'Plugin verbinden',
      },
      html: {
        title: 'HTML-Code kopieren',
        hint: 'Für Shopify, individuell entwickelte Websites und andere Systeme: Der Code zeigt das Siegel als von SiteNorma ausgelieferte SVG-Grafik, die auf die öffentliche Prüfseite verweist.',
        steps: {
          one: 'Wählen Sie oben Sprache, Hintergrund und Größe.',
          two: 'Kopieren Sie den Code.',
          three:
            'Fügen Sie ihn in das HTML der Fußzeile Ihrer Website oder Ihres Themes ein. Er braucht keine Skripte und ändert die Stile Ihrer Website nicht.',
        },
        label: 'HTML-Code',
        snippetHint:
          'Für {{language}}, Hintergrund {{theme}} und Größe {{size}}. Das Bild aktualisiert sich selbst, wenn das Siegel abläuft oder ausgesetzt wird.',
      },
    },
    verify: {
      title: 'Prüfen und gültig halten',
      intro:
        'Wer auf das Siegel klickt, gelangt auf eine öffentliche SiteNorma-Seite mit Name und Domain der Website, ihrem Status, den Daten der letzten Prüfung und des Ablaufs sowie dem Umfang des Geprüften.',
      open: 'Öffentliche Seite öffnen',
      locked: 'Die Seite wird beim Aktivieren des Siegels erstellt.',
      renews: 'Es erneuert sich von selbst, wenn eine neue vollständige Analyse die Anforderungen erfüllt.',
      expires: 'Es läuft {{days}} Tage nach der letzten vollständigen Analyse ab, wenn es keine neue gibt.',
      suspends:
        'Es wird ausgesetzt, wenn eine Analyse feststellt, dass die Anforderungen nicht mehr erfüllt sind.',
      live: 'Die Seite und das Bild des Siegels zeigen die Änderung sofort: Eine Website mit abgelaufenem oder ausgesetztem Siegel zeigt es nicht als gültig an.',
      lastReview: 'Letzte Prüfung: {{date}}.',
      validUntil: 'Gültig bis {{date}}, wenn keine neuere vollständige Analyse vorliegt.',
    },
  },
  statement: {
    tab: 'Erklärung zur Barrierefreiheit',
    title: 'Erklärung zur Barrierefreiheit',
    intro:
      'Erstellen Sie die Erklärung zur Barrierefreiheit dieser Website in vier Schritten: Sprachen wählen, Daten einmal ausfüllen, Dokument prüfen und genehmigen. Bei mehreren Sprachen erzeugt ein Formular alle; auf Ihrer Website zeigt das Skript die Sprache der Seite. Es ist ein informatives Dokument über den Stand der Barrierefreiheit, auch wenn noch Probleme offen sind. Die Genehmigung veröffentlicht es nicht auf der Website.',
    language: 'Sprachen der Erklärung',
    languages: {
      es: 'Español',
      ca: 'Català',
      en: 'English',
      fr: 'Français',
      de: 'Deutsch',
      prompt: 'Wählen Sie eine oder mehrere Sprachen. Auf Ihrer Website erkannte sind markiert.',
      noneDetected:
        'Wir haben die Sprachen Ihrer Website noch nicht erkannt. Wählen Sie, in welchen die Erklärung vorliegen soll.',
      helpLabel: 'Hilfe zu den Sprachen der Erklärung',
      help: 'Markieren Sie alle Sprachen, in denen Sie die Erklärung wollen. Die Daten im nächsten Schritt werden einmal ausgefüllt und erzeugen den Text in jeder Sprache. Auf Ihrer Website zeigt ein Skript die Sprache der Seite.',
      detected: 'erkannt',
      needOne: 'Wählen Sie mindestens eine Sprache, um fortzufahren.',
      selectedOne:
        'Die Erklärung wird auf {{name}} vorbereitet. Markieren Sie eine andere Sprache, wenn Sie diese entfernen wollen; mindestens eine muss bleiben.',
      selectedMany:
        'Die Erklärung wird in {{count}} Sprachen vorbereitet ({{list}}). Die Daten werden einmal für alle ausgefüllt.',
      removeApproved:
        'Wenn Sie fortfahren, wird die genehmigte Erklärung der entfernten Sprachen gelöscht (einschließlich Verlauf).',
      next: 'Weiter',
      unsupported: 'Es gibt auch Seiten in diesen Sprachen, für die wir noch keine Vorlage haben: {{list}}.',
      updated: 'Sprachen aktualisiert.',
    },
    published: 'Version {{n}} bestätigt',
    draft: 'Entwurf',
    none: 'nicht erstellt',
    cancel: 'Abbrechen',
    readOnly:
      'Ihre Rolle erlaubt nur, die Erklärung zu lesen. Bitten Sie jemanden mit der Rolle Editor oder höher, sie zu bearbeiten und zu bestätigen.',
    errors: {
      incomplete: 'Die Erklärung ist noch nicht vollständig: Prüfen Sie in Schritt 4, was fehlt.',
      permission: 'Ihre Rolle erlaubt keine Änderung der Erklärung. Nichts wurde gespeichert.',
      generic:
        'Die Aktion konnte nicht abgeschlossen werden. Versuchen Sie es erneut; es wurde nichts veröffentlicht.',
      noWordpress: 'Diese Website hat das SiteNorma-Plugin nicht in WordPress verbunden.',
    },
    steps: {
      language: 'Sprachen',
      data: 'Daten ausfüllen',
      review: 'Erzeugen und prüfen',
      validate: 'Prüfen und genehmigen',
    },
    status: {
      pendiente: 'Bestätigung ausstehend',
      validada: 'Bestätigt, noch nicht auf Ihrer Website veröffentlicht',
      publicada: 'Auf Ihrer Website veröffentlicht',
      last: 'Version {{n}}, genehmigt am {{date}}',
      changes: 'es gibt nicht genehmigte Änderungen',
    },
    data: {
      title: 'Daten ausfüllen',
      intro:
        'Wir fragen nur das Nötigste: die Angaben der für die Website verantwortlichen Stelle. Der Rest stammt aus Ihrer Website, dem Regelwerksprofil und den Analysen. Diese Daten gelten für alle gewählten Sprachen: Sie müssen sie nicht wiederholen.',
      entity: 'Verantwortliche Stelle',
      name: 'Name der Stelle',
      address: 'Adresse',
      email: 'E-Mail-Adresse',
      emailHint:
        'Sie ist auch die Kontaktadresse für Barrierefreiheit, sofern Sie in den erweiterten Optionen keine andere angeben.',
      website: 'Website',
      prefilled: 'Aus Ihrer Website übernommen. Sie können sie bei Bedarf ändern.',
      siteName: 'Name der Website',
      siteUrl: 'Adresse der Website',
      guidedTitle: 'Beschwerdeverfahren',
      advanced: 'Erweiterte Optionen',
      advancedHint: 'Steuernummer, Telefon, Kontakt, Geltungsbereich, Ausnahmen und Art der Bewertung',
      taxId: 'Steuernummer (optional)',
      phone: 'Telefon (optional)',
      contactEmail: 'Kontakt-E-Mail für Barrierefreiheit (optional)',
      contactEmailHint: 'Wenn Sie es leer lassen, wird die E-Mail-Adresse der Stelle verwendet.',
      contactUrl: 'Kontaktformular oder -seite (optional)',
      responseDays: 'Antwortfrist in Tagen (optional)',
      scope: 'Geltungsbereich (optional)',
      scopeHint:
        'Wenn die Erklärung nicht die ganze Website abdeckt (einen Bereich, eine Subdomain …), geben Sie es hier an.',
      exceptions: 'Ausnahmen (optional)',
      exceptionsHint:
        'Inhalte außerhalb des Geltungsbereichs oder unverhältnismäßige Belastung, in eigenen Worten und mit Begründung.',
      enforcement: 'Beschwerdeverfahren',
      enforcementHint:
        'Optional. Geben Sie an, bei wem und wie man sich beschweren kann, falls Ihre Stelle ein Verfahren hat. SiteNorma erfindet keines.',
      enforcementRequired:
        'Im öffentlichen Sektor verpflichtend. Geben Sie die zuständige Stelle und das für Sie geltende Beschwerdeverfahren an: SiteNorma erfindet keines.',
      preparationNote: 'Wie bewertet wurde, in eigenen Worten (optional)',
      generate: 'Erklärung erzeugen',
      regenerate: 'Erklärung erneut erzeugen',
      generated: 'Erklärung in allen gewählten Sprachen erzeugt. Prüfen Sie sie.',
    },
    evaluation: {
      label: 'Bewertung',
      state: {
        pendiente: 'Ausstehend',
        incompleta: 'Unvollständig',
        completada: 'Abgeschlossen',
      },
      pendingText: 'Führen Sie die Analyse und die manuelle Prüfung durch, um die Erklärung vorzubereiten.',
      incompleteBarriers:
        'Es wurden Barrieren gefunden. Schließen Sie die manuelle Prüfung ab, um die Konformität festzulegen.',
      incompleteClear:
        'Die automatische Analyse hat keine Barrieren gefunden. Schließen Sie die manuelle Prüfung ab, um die Konformität festzulegen.',
      pendingChecks: 'Offene Prüfungen ansehen',
      completePartial: 'Die Prüfung begründet teilweise Konformität. Die Mängel stehen in der Erklärung.',
      completeUndeclared: 'Die Prüfung erlaubt keinen Konformitätsgrad.',
    },
    document: {
      label: 'Dokument',
      draft: 'Entwurf',
      approved: 'Genehmigt',
    },
    evidence: {
      auto: 'Automatische Analyse',
      autoValue: 'Letzte Analyse am {{date}}: {{pages}} Seiten analysiert und {{problems}} offene Probleme.',
      noScan:
        'Es gibt noch keine abgeschlossene Analyse. Führen Sie unter „Analysen“ eine durch, damit die Erklärung sie berücksichtigt.',
      manual: 'Manuelle Prüfung',
      manualValue:
        '{{registered}} von {{total}} Kriterien geprüft. Die übrigen wurden nicht geprüft und die Erklärung sagt das.',
      outdated: 'Es gibt eine neuere Analyse als die, die für diesen Text verwendet wurde.',
    },
    review: {
      title: 'Erzeugen und prüfen',
      intro:
        'SiteNorma hat die Erklärung aus Ihren Daten, dem Regelwerksprofil der Website und der technischen Referenz ({{standard}}) erzeugt. So wird sie auf Ihrer Website aussehen.',
      generated: 'Erklärung mit der letzten Analyse aktualisiert.',
      update: 'Mit der letzten Analyse aktualisieren',
      previewLabel: 'Vorschau der Erklärung',
      empty: 'Es gibt noch keine Erklärung: Füllen Sie die Daten aus, um sie zu erzeugen.',
      readOnly:
        'Der Text ist schreibgeschützt. Wenn Sie etwas ändern müssen, gehen Sie zurück zu den Daten: Die Erklärung wird neu erzeugt.',
      edit: 'Daten ändern',
      continue: 'Prüfen und genehmigen',
    },
    validate: {
      title: 'Prüfen und genehmigen',
      blocked: 'Pflichtangaben fehlen vor der Genehmigung.',
      fixData: 'Daten ausfüllen',
      regime: 'Der öffentliche Sektor verlangt eine konkrete Konformitätssituation.',
      openAnalysis: 'Zur Analyse',
      seeText: 'Erklärung ansehen',
      confirm: 'Ich habe das Dokument geprüft und bestätige, dass die Angaben richtig sind.',
      confirmPending:
        'Ich habe das Dokument in den ausstehenden Sprachen geprüft und bestätige, dass die Angaben richtig sind.',
      action: 'Dokument genehmigen',
      actionPending: 'Ausstehende Sprachen genehmigen',
      clarification: 'Genehmigen bescheinigt nicht die Barrierefreiheit der Website.',
      back: 'Zurück zur Prüfung',
      done: 'Version {{n}} in allen bereiten Sprachen genehmigt. Wählen Sie nun, wie sie veröffentlicht wird.',
      donePending: 'Genehmigt: {{list}}. Sie können jetzt das HTML jeder Sprache kopieren.',
      pendingLangs_one:
        '{{list}} muss noch genehmigt werden. Bis dahin enthalten Skript und HTML nur die bereits genehmigten Sprachen.',
      pendingLangs_other:
        '{{list}} müssen noch genehmigt werden. Bis dahin enthalten Skript und HTML nur die bereits genehmigten Sprachen.',
      unvalidatedChanges:
        'Es gibt Änderungen nach Version {{n}}: Ihre Website zeigt weiter diese Version, bis Sie die neue genehmigen.',
    },
    problems: {
      entity: 'Der Name der Stelle fehlt.',
      address: 'Die Adresse der Stelle fehlt.',
      email: 'Die E-Mail-Adresse der Stelle fehlt.',
      site: 'Die Adresse der Website fehlt.',
      contact: 'Eine Kontakt-E-Mail für Barrierefreiheit fehlt.',
      enforcement: 'Das Beschwerdeverfahren fehlt (im öffentlichen Sektor verpflichtend).',
      conformity:
        'Der öffentliche Sektor verlangt eine konkrete Konformitätssituation, und die Bewertung begründet sie nicht.',
      blank: 'Der Text enthält noch auszufüllende Angaben: Gehen Sie zurück zu den Daten.',
      empty: 'Es gibt noch keine Erklärung: Füllen Sie die Daten aus, um sie zu erzeugen.',
    },
    publication: {
      title: 'Auf Ihrer Website veröffentlichen',
      intro:
        'Version {{n}} ist genehmigt ({{date}}). Die Genehmigung stellt sie nicht auf Ihre Website: Wählen Sie eine Methode, folgen Sie den Schritten und markieren Sie sie, wenn sie auf der Seite ist. Skript und Link zeigen immer die letzte genehmigte Version.',
      choose: 'Wählen Sie, wie Sie die Erklärung hinzufügen',
      languageScript:
        'Ein Skript gilt für {{list}}. Es zeigt die Sprache der Seite (lang-Attribut oder Pfad) sofort beim Laden, ohne zweite Anfrage.',
      languageLink: 'Dieser Link gehört zur Erklärung auf {{name}}. Jede Sprache hat ihren eigenen.',
      languageHtml:
        'Kopieren Sie das HTML jeder Sprache und fügen Sie es auf der passenden Seite ein. Sprache wählen und kopieren.',
      mark: {
        script: 'Ich habe das Skript hinzugefügt',
        link: 'Ich habe die Seite verlinkt',
        html: 'Ich habe das HTML eingefügt',
        wordpress: 'Ich habe die Veröffentlichung in WordPress angefordert',
      },
      markedOn: 'Am {{date}} als veröffentlicht markiert.',
      saved: {
        script: 'Als per Skript veröffentlicht markiert.',
        link: 'Als per Link veröffentlicht markiert.',
        html: 'Als per HTML veröffentlicht markiert.',
        wordpress: 'WordPress-Veröffentlichungsanfrage erfasst.',
      },
    },
    delivery: {
      recommended: 'Empfohlen',
      script: 'Code-Ausschnitt',
      scriptSummary: 'Aktualisiert sich selbst bei einer neuen Freigabe und folgt der Sprache der Seite.',
      scriptHint: 'Kopieren Sie den Code. Bis der Text bereit ist, erscheint ein Ladehinweis.',
      link: 'Gehosteter Link',
      linkSummary: 'Von SiteNorma gehostete Seite, die sich bei Freigabe selbst aktualisiert.',
      linkHint: 'Kopieren Sie diesen Link und nutzen Sie ihn auf Ihrer Website, zum Beispiel in der Fußzeile.',
      html: 'HTML',
      htmlSummary: 'Kopieren Sie das HTML von Hand. Bei einer neuen Freigabe müssen Sie es erneut einfügen.',
      htmlHint: 'Kopieren Sie dieses HTML und fügen Sie es auf Ihrer Website-Seite ein.',
      htmlLangs: 'HTML-Sprache',
      htmlNote:
        'Dieses HTML aktualisiert sich nicht selbst: bei einer neuen Freigabe erneut kopieren. Für automatische Updates nutzen Sie den Code-Ausschnitt oder den Link.',
      wordpress: 'WordPress',
      wordpressSummary: 'Das SiteNorma-Plugin erstellt oder aktualisiert die Seite in Ihrem WordPress.',
      wordpressHint:
        'Markieren Sie diese Option und veröffentlichen Sie im SiteNorma-Plugin in WordPress (oder warten Sie auf die stündliche Synchronisation).',
      wordpressNote: 'Das Plugin bestätigt, wann die Seite auf Ihrer Website veröffentlicht ist.',
      wordpressConnect:
        'Verbinden Sie das SiteNorma-Plugin in WordPress, um die Erklärung von dort zu veröffentlichen.',
      wordpressGo: 'Zu Integrationen → WordPress',
      stepCopy: 'Schritt 1: diesen Code kopieren',
      stepPaste: 'Schritt 2: auf der Seite Ihrer Website einfügen, wo die Erklärung erscheinen soll.',
      stepCopyLink: 'Schritt 1: diesen Link kopieren',
      stepPasteLink: 'Schritt 2: von Ihrer Website verlinken, zum Beispiel in der Fußzeile.',
      stepCopyHtml: 'Schritt 1: HTML auf {{name}} kopieren',
      quality:
        'Während das Skript ankommt, erscheint «Wird geladen…» in der Sprache der Seite. Der Text aller genehmigten Sprachen steckt im Skript selbst, lädt asynchron und fügt keine Abhängigkeiten hinzu; er nutzt echte Überschriften und Listen und übernimmt Schrift und Farben Ihrer Website. Falls er nicht angezeigt werden kann, bleibt ein Link zur Erklärung.',
      copy: 'Kopieren',
      copied: 'Kopiert',
    },
    versions: {
      title: 'Versionen',
      hint: 'Jede bestätigte Version wird mit Datum und der bestätigenden Person aufbewahrt. Sie können eine als Entwurf wiederherstellen, um sie zu aktualisieren.',
      version: 'Version {{n}}',
      by: 'bestätigt von {{name}}',
      view: 'Ansehen',
      hide: 'Ausblenden',
      restore: 'Als Entwurf wiederherstellen',
      restored: 'Version {{n}} ist jetzt der Entwurf. Es wird nichts veröffentlicht, bis Sie ihn bestätigen.',
      modify: 'Daten ändern und eine neue Version erstellen',
    },
  },
  pagesList: {
    title: 'Analysierte Seiten',
    intro: 'Inventar der Website (nicht nur die letzte Analyse): jede Seite zeigt ihr letztes Ergebnis.',
    figures: {
      analysed: 'Analysierte Seiten',
      pending: 'Mit offenen Problemen',
      clean: 'Ohne offene Probleme',
    },
    empty: 'Es wurden noch keine Seiten analysiert. Starten Sie mit einer Analyse unter „Analysen“.',
    notFound: 'Diese Seite ist nicht mehr in den Ergebnissen dieser Website.',
    noMatch: 'Keine Seite entspricht Ihrer Auswahl. Ändern Sie Filter oder Suche.',
    filter: {
      label: 'Anzeigen',
      todas: 'Alle Seiten',
      pendientes: 'Mit offenen Problemen',
      limpias: 'Ohne offene Probleme',
    },
    pending_one: '{{count}} offenes Problem',
    pending_other: '{{count}} offene Probleme',
    none: 'Keine offenen Probleme',
    verified_one: '{{count}} Korrektur verifiziert',
    verified_other: '{{count}} Korrekturen verifiziert',
    lastAnalysis: 'Letzte Analyse: {{date}}',
  },
  nav: {
    label: 'Dashboard',
    sites: 'Websites',
    organization: 'Organisation',
    users: 'Nutzer',
    menu: 'Menü',
    integrations: 'Integrationen',
  },
  mcp: {
    title: 'MCP für Cursor und andere Agenten',
    intro:
      'Der Agent liest Ihre Analysen und wendet die Korrekturen im lokalen Code Ihrer Website an. Er schreibt nicht auf die veröffentlichte Website: Sie veröffentlichen die Änderungen.',
    note: 'Das Token ist persönlich und handelt mit Ihren Berechtigungen. Teilen Sie es nicht und committen Sie es nicht ins Repository. Bei Verlust widerrufen Sie es und erstellen Sie ein neues.',
    create: {
      title: 'Token erstellen',
      name: 'Name (optional)',
      namePlaceholder: 'z. B. Cursor am Laptop',
      button: 'Token erstellen',
      working: 'Wird erstellt…',
      limit:
        'Sie haben das Maximum von {{max}} aktiven Tokens erreicht. Widerrufen Sie eines, um ein neues zu erstellen.',
    },
    created: {
      title: 'Link für den Agenten',
      body: 'Kopieren Sie ihn und fügen Sie ihn in den Chat des Agenten ein (Cursor oder einen anderen). Der Agent liest die Anweisungen des Links und konfiguriert das SiteNorma-MCP. Der Link enthält das Token, wird nur einmal angezeigt und darf weder geteilt noch anderswo eingefügt werden.',
      copyLink: 'Link kopieren',
      linkCopied: 'Link kopiert.',
      copy: 'Token kopieren',
      copied: 'Token kopiert.',
      configTitle: 'Konfiguration für andere Agenten',
      configHint:
        'Der Link lässt den Agenten diese Konfiguration schreiben. Der Befehl ist der Pfad des Starters auf diesem Computer. Fehlt die Datei, sagt der Agent das.',
      copyConfig: 'Konfiguration kopieren',
      configCopied: 'Konfiguration kopiert.',
      close: 'Ich habe das Token gespeichert',
    },
    steps: {
      title: 'So verwenden Sie es',
      one: 'Erstellen Sie auf dieser Seite ein Token.',
      two: 'Kopieren Sie den Link und fügen Sie ihn in den Chat des Agenten ein. Damit wird das SiteNorma-MCP konfiguriert.',
      three:
        'Öffnen Sie den Code Ihrer Website (Theme oder Repository) im Editor und bitten Sie den Agenten, die SiteNorma-Probleme zu beheben.',
      four: 'Veröffentlichen Sie die Änderungen und starten Sie im Panel „Korrektur prüfen“ oder eine neue Analyse.',
    },
    list: {
      title: 'Aktive Tokens',
      empty: 'Es gibt noch kein MCP-Token.',
      tableLabel: 'MCP-Tokens (die Tabelle scrollt)',
      name: 'Name',
      prefix: 'Token',
      owner: 'Erstellt von',
      created: 'Erstellt',
      lastSeen: 'Zuletzt verwendet',
      never: 'Noch keines',
      actions: 'Aktionen',
      revoke: 'Widerrufen',
      revokeTitle: '„{{name}}“ widerrufen?',
      revokeBody:
        'Ein Agent mit diesem Token kann Ihre Analysen nicht mehr lesen. Sie können jederzeit ein neues erstellen.',
      revokeConfirm: 'Widerrufen',
      cancel: 'Abbrechen',
      revoked: 'Das Token „{{name}}“ wurde widerrufen.',
      usage: '{{mine}} von {{max}} Ihrer aktiven Tokens in dieser Organisation.',
    },
    errors: {
      limit: 'Sie haben das Maximum aktiver Tokens erreicht.',
      generic: 'Die Aktion konnte nicht abgeschlossen werden. Versuchen Sie es erneut.',
    },
  },
  integrations: {
    title: 'Integrationen',
    intro:
      'Verbinden Sie SiteNorma mit anderen Plattformen und Ihrer Entwicklungsumgebung, um Ergebnisse einzusehen und Barrierefreiheitsprobleme zu beheben.',
    nav: 'Integrationsabschnitte',
    mcp: 'MCP',
    wordpress: 'WordPress',
  },
  wordpress: {
    title: 'WordPress-Plugin',
    intro:
      'Installieren Sie das SiteNorma-Plugin in Ihrem WordPress und sehen Sie die Ergebnisse dieser Website, ohne das WordPress-Dashboard zu verlassen. Das Plugin zeigt nur die Daten der Website, auf der es installiert ist: Vollständige Analysen und PDF-Berichte erstellen Sie immer hier, auf der Plattform.',
    note: 'Die Ergebnisse sind eine automatische Schätzung: Automatische Tests erkennen nur Probleme, alles Übrige erfordert eine manuelle Prüfung. Das Plugin zeigt dieselben Informationen wie hier.',
    download: {
      eyebrow: 'Download',
      title: 'SiteNorma für WordPress',
      meta: 'Version {{version}} · {{size}} · erfordert WordPress {{wp}} und PHP {{php}}',
      button: 'Plugin herunterladen',
      checksum: 'Integrität der Datei prüfen',
      unavailable: 'Das Plugin steht noch nicht zum Download bereit.',
    },
    steps: {
      title: 'So installieren Sie es',
      one: 'Laden Sie die ZIP-Datei herunter.',
      two: 'Gehen Sie in Ihrem WordPress zu Plugins → Neu hinzufügen → Plugin hochladen und wählen Sie die ZIP-Datei.',
      three:
        'Aktivieren Sie das Plugin und klicken Sie auf „Mit SiteNorma verbinden“. Sie gelangen hierher, um die Verbindung zu genehmigen.',
      four: 'Ihre Website erscheint auf der Plattform, wird automatisch verifiziert, und das Plugin zeigt ihre Ergebnisse.',
    },
    usage: {
      label: 'Mit dem Plugin verknüpfte Websites',
      of: '{{used}} von {{limit}} verknüpften Websites in Ihrem Tarif ({{plan}})',
      unlimited: '{{used}} verknüpfte Websites (Ihr Tarif hat keine Begrenzung)',
    },
    list: {
      title: 'Verknüpfte Websites',
      empty: 'Noch keine Website ist mit dem Plugin verknüpft.',
      tableLabel: 'Mit dem Plugin verknüpfte Websites (die Tabelle lässt sich scrollen)',
      site: 'Website',
      status: 'Inhaberschaft',
      verified: 'Verifiziert',
      unverified: 'Nicht verifiziert',
      versions: 'Versionen',
      versionsValue: 'WordPress {{wp}} · Plugin {{plugin}}',
      lastSeen: 'Letzte Verbindung',
      never: 'Noch keine',
      linkedBy: 'Verknüpft von',
      actions: 'Aktionen',
      unlink: 'Trennen',
      unlinkTitle: '{{name}} trennen?',
      unlinkBody:
        'Das Plugin dieser Website zeigt keine Ergebnisse mehr an, sobald es es erneut versucht. Die Website und ihr Verlauf bleiben in SiteNorma erhalten; Sie können sie jederzeit wieder verknüpfen.',
      unlinkConfirm: 'Trennen',
      cancel: 'Abbrechen',
      unlinked: '{{name}} wurde getrennt.',
    },
    tab: {
      name: 'WordPress',
      title: 'WordPress-Plugin',
      none: 'Dieser Website ist keine WordPress-Installation zugeordnet.',
      link: 'In Integrationen verwalten',
      open: 'In WordPress öffnen',
    },
    connect: {
      title: 'WordPress mit SiteNorma verbinden',
      intro:
        'Ein WordPress möchte sich mit Ihrem Konto verknüpfen. Prüfen Sie, um welche Website es sich handelt, bevor Sie genehmigen.',
      site: 'Website, die verknüpft wird',
      organization: 'Organisation',
      account: 'Konto',
      scopeTitle: 'Was das Plugin tun kann',
      can1: 'Diese Website in Ihrer Organisation registrieren und verifizieren, dass sie Ihnen gehört.',
      can2: 'In WordPress die Ergebnisse dieser Website anzeigen, und nur dieser.',
      can3: 'Eine Schnellanalyse dieser Website anfordern, im Rahmen der Grenzen Ihres Tarifs.',
      cannot:
        'Es kann keine anderen Websites sehen, Ihr Konto nicht ändern und keine PDF-Berichte erstellen: Das geht nur von hier aus.',
      revoke: 'Sie können die Verknüpfung jederzeit auf dieser Plattform trennen.',
      warning: 'Genehmigen Sie nur, wenn Sie selbst darum gebeten haben, {{host}} zu verbinden.',
      approve: 'Verbindung genehmigen',
      working: 'Verbindung wird hergestellt …',
      cancel: 'Abbrechen',
      home: 'Zum Dashboard',
      invalid:
        'Der Verbindungslink ist ungültig oder unvollständig. Gehen Sie zurück zum Plugin in Ihrem WordPress und klicken Sie erneut auf „Mit SiteNorma verbinden“.',
      errors: {
        generic: 'Die Verbindung konnte nicht genehmigt werden. Bitte versuchen Sie es gleich noch einmal.',
        permiso:
          'Ihre Rolle erlaubt es nicht, Websites zu verknüpfen. Bitten Sie eine Person mit der Rolle Editor, Administrator oder Inhaber, es zu tun.',
        'limite-webs':
          'Sie haben die maximale Zahl verknüpfter Websites Ihres Tarifs erreicht. Trennen Sie eine Website oder wechseln Sie den Tarif.',
        callback: 'Die Rücksprungadresse gehört nicht zu dieser Website, daher kann es nicht weitergehen.',
        url: 'Diese Adresse ist nicht öffentlich. Es lassen sich nur Websites verknüpfen, die aus dem Internet erreichbar sind.',
        vinculada:
          'Diese Website wurde von einer anderen Person der Organisation verknüpft: Nur sie oder ein Administrator kann sie erneut verknüpfen.',
        conflicto:
          'Eine andere Verknüpfung dieser Website lief gleichzeitig. Beginnen Sie noch einmal im Plugin.',
        limite: 'Zu viele Versuche. Warten Sie einen Moment und versuchen Sie es erneut.',
      },
    },
  },
  users: {
    title: 'Nutzer',
    intro:
      'Wie sich die Registrierungen bei SiteNorma entwickeln, die angelegten Konten und der Tarif jedes Kontos. Nur Superadministratoren sehen diese Seite.',
    tableLabel: 'Nutzer des Systems (die Tabelle lässt sich scrollen)',
    count_one: '{{count}} Nutzer',
    count_other: '{{count}} Nutzer',
    columns: {
      user: 'Nutzer',
      verified: 'E-Mail verifiziert',
      organizations: 'Organisationen',
      signedUp: 'Registriert',
      sites: 'Websites',
      scans: 'Analysen',
      lastSeen: 'Letzte Aktivität',
      status: 'Status',
      plan: 'Tarif',
    },
    verifiedYes: 'Ja',
    verifiedNo: 'Nein',
    noOrganizations: 'Keine',
    neverSeen: 'Nie',
    planOf: 'Tarif von {{name}}',
    limitMonth: '{{count}} Seiten pro Monat',
    limitNone: 'Ohne Begrenzung',
    infinite: 'Tarif „Unbegrenzt“ aktivieren',
    infiniteOn: 'Tarif „Unbegrenzt“ aktiv',
    saved: 'Tarif von {{name}} auf {{plan}} geändert.',
    error: 'Der Tarif konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
    plans: {
      gratis: 'Kostenlos',
      pro: 'Pro',
      agencia: 'Agentur',
      'a-medida': 'Individuell',
      infinita: 'Unbegrenzt',
    },
    wordpress: {
      title: 'WordPress-Installationen',
      intro:
        'Mit dem Plugin verknüpfte Websites in allen Konten. Wird eine getrennt, zeigt das Plugin bei der nächsten Anfrage keine Ergebnisse mehr an; die Website und ihr Verlauf bleiben erhalten.',
      tableLabel: 'Verknüpfte WordPress-Installationen (die Tabelle lässt sich scrollen)',
      empty: 'Es ist keine Installation verknüpft.',
      organization: 'Organisation',
      unlinkBody:
        'Diese Installation funktioniert sofort nicht mehr, auch wenn das Konto aktiv bleibt. Das wird im Änderungsprotokoll festgehalten.',
    },
    overview: {
      title: 'Registrierungen',
      period: 'Zeitraum der Diagramme',
      lastDays_one: 'Letzter Tag',
      lastDays_other: 'Letzte {{count}} Tage',
    },
    kpi: {
      accounts: 'Konten insgesamt',
      last7: 'Registrierungen in 7 Tagen',
      last30: 'Registrierungen in 30 Tagen',
      trend: '{{change}} gegenüber den vorherigen 7 Tagen ({{previous}})',
      waitlist: 'Warteliste, 30 Tage',
      audits: 'Kostenlose Audits, 30 Tage',
      total_one: '{{count}} insgesamt',
      total_other: '{{count}} insgesamt',
      blocked: 'Gesperrte Konten',
    },
    chart: {
      signups: 'Kontoregistrierungen pro Tag',
      signupsColumn: 'Registrierungen',
      waitlist: 'Wartelisten-Anmeldungen pro Tag',
      waitlistColumn: 'Auf der Warteliste',
      label: '{{title}}, vom {{from}} bis {{to}}: {{total}} insgesamt, höchstens {{peak}} an einem Tag.',
      peak: 'Höchstwert: {{count}} an einem Tag',
      data: 'Diagrammdaten anzeigen',
      day: 'Tag',
    },
    funnel: {
      title: 'Was nach der Registrierung passiert',
      intro: 'Konten, die den jeweiligen Schritt erreicht haben, bezogen auf alle Registrierungen.',
      signedUp: 'Registriert',
      verified: 'E-Mail verifiziert',
      organization: 'Gehören zu einer Organisation',
      site: 'Haben eine Website hinzugefügt',
      scan: 'Haben eine Analyse gestartet',
      value: '{{count}} · {{percent}} %',
    },
    filters: {
      search: 'Nach Name, E-Mail oder Organisation suchen',
      show: 'Anzeigen',
      all: 'Alle Konten',
      unverified: 'Ohne verifizierte E-Mail',
      noSite: 'Ohne Website',
      blocked: 'Gesperrt',
      shown: '{{count}} von {{total}} Nutzern werden angezeigt.',
    },
    active: 'Aktiv',
    blocked: 'Gesperrt',
    administrator: 'Administrator',
    block: 'Sperren',
    unblock: 'Entsperren',
    blockTitle: '{{name}} sperren?',
    blockBody:
      'Die Person kann sich nicht mehr anmelden, und ihre offenen Sitzungen werden beendet. Ihre Daten werden nicht gelöscht, und Sie können das Konto jederzeit entsperren.',
    blockConfirm: 'Sperren',
    cancel: 'Abbrechen',
    blockedDone: '{{name}} ist gesperrt.',
    unblockedDone: '{{name}} kann sich wieder anmelden.',
    blockError: 'Der Status des Kontos konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
  },
  members: {
    tableLabel: 'Personen der Organisation (die Tabelle lässt sich scrollen)',
    title: 'Organisation: {{name}}',
    membersTitle: 'Personen',
    name: 'Name',
    email: 'E-Mail',
    role: 'Rolle',
    roleOf: 'Rolle von {{name}}',
    actions: 'Aktionen',
    you: '(Sie)',
    remove: 'Entfernen',
    removeOf: '{{name}} entfernen',
    removeTitle: '{{name}} aus der Organisation entfernen?',
    removeIntro:
      'Die Person sieht die Websites und Analysen der Organisation nicht mehr. Sie können sie später erneut einladen.',
    removeConfirm: 'Entfernen',
    cancel: 'Abbrechen',
    roleSaved: 'Rolle von {{name}} auf {{role}} geändert.',
    removed: '{{name}} gehört nicht mehr zur Organisation.',
    add: 'Person hinzufügen',
    invitationsTitle: 'Ausstehende Einladungen',
    invitationItem: '{{email}} · {{role}} · läuft am {{date}} ab',
    cancelInvitation: 'Einladung zurückziehen',
    cancelInvitationOf: 'Einladung an {{email}} zurückziehen',
    invitationCancelled: 'Einladung an {{email}} zurückgezogen.',
    inviteTitle: 'Person einladen',
    inviteIntro:
      'Wir senden der Person eine E-Mail mit einem Link zum Beitreten. Er läuft nach 48 Stunden ab.',
    inviteEmail: 'E-Mail',
    inviteRole: 'Rolle',
    inviteSubmit: 'Einladung senden',
    invited: 'Einladung an {{email}} gesendet.',
    roleHints: {
      owner: 'Alles, auch das Löschen der Organisation.',
      admin: 'Alles außer dem Löschen der Organisation: Websites, Analysen und Personen.',
      editor: 'Websites hinzufügen, verifizieren und analysieren sowie ihre Probleme bearbeiten.',
      viewer: 'Nur ansehen.',
    },
    errors: {
      generic: 'Die Änderung konnte nicht vorgenommen werden. Möglicherweise erlaubt Ihre Rolle sie nicht.',
      already: 'Diese Person gehört bereits zur Organisation oder hat schon eine Einladung.',
    },
  },
  report: {
    download: 'PDF-Bericht herunterladen',
    working: 'Bericht wird vorbereitet …',
    started: 'Der PDF-Bericht wird vorbereitet. Das kann einige Sekunden dauern.',
    ready: 'Bericht heruntergeladen.',
    note: 'Der PDF-Bericht ist vorerst auf Spanisch, ebenso wie die Texte der Regeln.',
    errors: {
      informe: 'Der Bericht konnte nicht vorbereitet werden. Versuchen Sie es in einigen Minuten erneut.',
      limite:
        'Sie haben viele Berichte für diese Website angefordert. Versuchen Sie es in einer Stunde erneut.',
      'sin-terminar': 'Die Analyse ist noch nicht abgeschlossen.',
    },
  },
  scans: {
    title: 'Analysen',
    emptyTitle: 'Website analysieren',
    emptyText: 'Wählen Sie den Typ und prüfen Sie die Seiten, bevor Sie starten.',
    prepareAgain: 'Neue Analyse',
    historyCheck: 'Nur Überprüfung',
    prepare: {
      action: 'Meine Website analysieren',
      title: 'Analyse vorbereiten',
      loadFailed: 'Wir konnten die Übersicht nicht vorbereiten. Es wurde nichts gestartet.',
      profile: 'Normatives Profil',
      profileUnset:
        'Sie haben noch kein normatives Profil gewählt. Geben Sie an, welche Regeln als Referenz gelten. Später können Sie es in den Einstellungen der Website ändern.',
      scopeTitle: 'Art der Analyse',
      summaryTitle: 'Zusammenfassung',
      next: 'Weiter',
      back: 'Zurück',
      modes: {
        pagina: {
          label: 'Eine Seite',
          hint: 'Analysiert eine Seite Ihrer Website.',
        },
        rapido: {
          label: 'Schnellanalyse',
          hint: 'Analysiert bis zu {{count}} Seiten Ihrer Website.',
        },
        completo: {
          label: 'Vollständige Analyse',
          hint: 'Analysiert bis zu {{count}} Seiten Ihrer Website.',
        },
      },
      needsOwnership: 'Erfordert die Bestätigung der Inhaberschaft.',
      verifyAction: 'Meine Website bestätigen',
      checks:
        'Wir prüfen die Barrierefreiheit automatisch nach {{standard}}. Manche Aspekte erfordern eine manuelle Prüfung.',
      methodology: 'So analysieren wir Ihre Website',
      analysisLimitTitle: 'Limit pro Analyse',
      analysisLimit_one: 'Bis zu {{count}} Seite mit der gewählten Option.',
      analysisLimit_other: 'Bis zu {{count}} Seiten mit der gewählten Option.',
      analysisLimitExact_one: 'Verbraucht {{count}} Seite.',
      analysisLimitExact_other: 'Verbraucht {{count}} Seiten.',
      monthlyQuotaTitle: 'Monatliches Kontingent',
      monthlyUsedOf: '{{used}} von {{limit}} Seiten genutzt.',
      monthlyAvailable_one: '{{count}} Seite verfügbar.',
      monthlyAvailable_other: '{{count}} Seiten verfügbar.',
      monthlyUnlimited: 'Kein Seitenlimit.',
      monthlyAnalysed_one: '{{count}} Seite in diesem Monat analysiert.',
      monthlyAnalysed_other: '{{count}} Seiten in diesem Monat analysiert.',
      optionOverQuota:
        'Das Limit pro Analyse beträgt {{max}} Seiten und Ihnen bleiben {{remaining}} Seiten im monatlichen Kontingent.',
      pagesHelp: 'So zählen wir Seiten',
      pages: {
        title: 'Welche Seiten möchten Sie analysieren?',
        how: 'Wie sie gewählt werden',
        auto: {
          label: 'Automatische Auswahl',
          hint_one:
            'SiteNorma startet mit der Startseite und wählt 1 repräsentative Seite (Sitemap und Links der Startseite).',
          hint_other:
            'SiteNorma startet mit der Startseite und wählt bis zu {{count}} repräsentative Seiten (Sitemap und Links der Startseite).',
        },
        manual: {
          label: 'Seiten auswählen',
          hint_one: 'Wählen Sie 1 Adresse Ihrer Website.',
          hint_other: 'Wählen Sie bis zu {{count}} Adressen Ihrer Website.',
          paidOnly: 'In den kostenpflichtigen Tarifen verfügbar.',
        },
        autoOne: 'Es wird die Startseite der Website analysiert: {{url}}.',
        autoMulti:
          'SiteNorma erkennt Seiten Ihrer Website und wählt bis zu {{count}} der repräsentativsten aus.',
        search: 'Seiten suchen',
        searchPlaceholder: 'Titel oder Adresse',
        listLabel: 'Erkannte oder früher analysierte Seiten',
        chosen: 'Ausgewählt: {{count}} von {{max}}',
        empty: 'Keine Seiten passen. Sie können unten eine Adresse hinzufügen.',
        addLabel: 'Adresse hinzufügen',
        addHint:
          'Sie muss zur gleichen Domain wie die Website gehören. Zum Beispiel /kontakt oder https://ihrewebsite.com/kontakt',
        addPlaceholder: 'https://ihrewebsite.com/kontakt',
        addAction: 'Zur Auswahl hinzufügen',
        addInvalid:
          'Geben Sie eine Adresse dieser Website ein, zum Beispiel /kontakt oder https://ihrewebsite.com/kontakt',
        addDuplicate: 'Diese Adresse ist bereits in der Auswahl.',
        addLimit_one: 'Diese Analyse erlaubt höchstens {{count}} Seite.',
        addLimit_other: 'Diese Analyse erlaubt höchstens {{count}} Seiten.',
        summaryTitle: 'Zusammenfassung der Auswahl',
        summaryCount_one: '{{count}} Seite ausgewählt:',
        summaryCount_other: '{{count}} Seiten ausgewählt:',
      },
      noPages: {
        title: 'Es sind keine Seiten mehr verfügbar',
        text: 'Sie haben das monatliche Kontingent dieses Monats verbraucht. Der Zähler wird am {{date}} zurückgesetzt.',
      },
      insufficient:
        'Im monatlichen Kontingent reichen die Seiten nicht: Das Limit pro Analyse beträgt {{planned}} und Ihnen bleiben {{remaining}} Seiten verfügbar. Der Zähler wird am {{date}} zurückgesetzt.',
      useOnePage: 'Nur eine Seite analysieren',
      seePlans: 'Tarife ansehen',
      check: {
        mode: 'Korrektur prüfen',
        modeHint_one:
          'Nur die Seite mit der Korrektur, die Sie prüfen möchten, auf dem Desktop und auf dem Mobilgerät.',
        modeHint_other:
          'Nur die {{count}} Seiten mit den Korrekturen, die Sie prüfen möchten, auf dem Desktop und auf dem Mobilgerät.',
        title: 'Was geprüft wird',
        intro:
          'Das ist eine Prüfung von Korrekturen, keine Analyse Ihrer ganzen Website: Sie prüft nur die Seiten dieser Elemente und sucht auf anderen nicht nach Problemen.',
        elements_one: '{{count}} Element',
        elements_other: '{{count}} Elemente',
        pagesTitle: 'Seiten, die analysiert werden',
        devices: 'Geräte: {{list}}.',
        conditionsTitle: 'Unter welchen Bedingungen',
        conditions:
          'Jede Seite wird so geladen, wie ein neuer Besucher sie sieht, ohne angemeldete Sitzung, auf dem Desktop und auf dem Mobilgerät. Erscheint ein Element nur in einem Pop-up oder nach der Anmeldung, lautet das Ergebnis „Nicht automatisch bestätigt“ oder „Manuelle Prüfung erforderlich“, nie „behoben“.',
        scope_one: 'Umfang: {{count}} Seite Ihrer Website.',
        scope_other: 'Umfang: {{count}} Seiten Ihrer Website.',
        skipped_one: '{{count}} Element wird nicht geprüft (es ist archiviert oder verworfen).',
        skipped_other: '{{count}} Elemente werden nicht geprüft (sie sind archiviert oder verworfen).',
        tooMany:
          'Die Korrekturen liegen auf {{count}} Seiten, und eine Prüfung kann höchstens {{max}} umfassen. Prüfen Sie jeweils weniger Elemente.',
        nothing: 'Mit den gewählten Elementen gibt es nichts zu prüfen.',
        other: 'Weitere Analysen',
        result:
          'Am Ende zeigt jedes Element sein Ergebnis: „Wird weiterhin erkannt“, „Bei der letzten Prüfung nicht erkannt“, „Nicht automatisch bestätigt“ oder „Manuelle Prüfung erforderlich“. Nur eine vergleichbare Prüfung, die es nicht erkennt, erlaubt es, die Arbeit zu archivieren.',
      },
      start: 'Analyse starten',
      startAuto_one: '1 Seite analysieren',
      startAuto_other: 'Bis zu {{count}} Seiten analysieren',
      startExact_one: '1 Seite analysieren',
      startExact_other: '{{count}} Seiten analysieren',
      starting: 'Analyse wird gestartet …',
      cancel: 'Abbrechen',
      startFailed:
        'Wir konnten die Analyse nicht starten. Es wurde keine Seite verbraucht: Sie können es erneut versuchen.',
    },
    errors: {
      'en-curso': 'Für diese Website läuft bereits eine Analyse.',
      verificacion: 'Für die vollständige Analyse muss die Inhaberschaft der Website verifiziert sein.',
      limite: 'Sie haben heute viele Analysen gestartet. Versuchen Sie es morgen erneut.',
      saldo:
        'Für diese Analyse sind in diesem Monat nicht mehr genug Seiten übrig. Es wurde nichts gestartet.',
      permiso: 'Ihre Rolle erlaubt es nicht, Websites zu analysieren.',
      plan: 'Seiten von Hand zu wählen ist in den kostenpflichtigen Tarifen verfügbar. Es wurde nichts gestartet.',
      urls: 'Eine Adresse ist ungültig, doppelt oder gehört nicht zu dieser Website. Es wurde nichts gestartet.',
      'limite-paginas':
        'Sie haben mehr Seiten gewählt, als diese Art der Analyse zulässt. Es wurde nichts gestartet.',
      'nada-que-comprobar':
        'Es gibt nichts zu prüfen: Die gewählten Elemente sind archiviert, verworfen oder existieren nicht mehr.',
      'demasiadas-paginas': 'Diese Korrekturen liegen auf zu vielen Seiten für eine einzige Prüfung.',
      'no-completable': 'Nur eine teilweise abgeschlossene vollständige Analyse kann vervollständigt werden.',
      'nada-que-completar': 'In dieser Analyse sind keine ausstehenden Seiten mehr zu vervollständigen.',
    },
    types: {
      pagina: 'Eine Seite',
      rapido: 'Schnell',
      completo: 'Vollständig',
      personalizado: 'Benutzerdefiniert',
      comprobacion: 'Prüfung von Korrekturen',
    },
    latestTitle: 'Letzte Analyse',
    lastAvailableTitle: 'Letztes verfügbares Ergebnis',
    meta: '{{date}} · {{type}}',
    scoreNote: 'Entspricht nicht der rechtlichen Konformität.',
    summary: {
      kinds: {
        rapido: 'schnell',
        completo: 'vollständig',
        personalizado: 'benutzerdefiniert',
        comprobacion: 'zur Prüfung',
      },
      pages_one: '{{count}} Seite',
      pages_other: '{{count}} Seiten',
      found_one: 'Die Analyse ({{kind}}) von {{pages}} hat {{count}} Barrierefreiheitsproblem erkannt.',
      found_other: 'Die Analyse ({{kind}}) von {{pages}} hat {{count}} Barrierefreiheitsprobleme erkannt.',
      none: 'Die Analyse ({{kind}}) von {{pages}} hat mit den automatischen Tests keine Barrierefreiheitsprobleme erkannt.',
      nothing: 'Die Analyse ({{kind}}) konnte keine Seite analysieren.',
      pendingReview: 'Einige Prüfungen warten noch auf die manuelle Prüfung.',
    },
    noScore: 'Keine Schätzung: Es konnte keine Seite analysiert werden.',
    blocked:
      'Die Website hat die automatische Analyse auf {{count}} Seite(n) blockiert. Wenn die Ursache ihre robots.txt ist, verifizieren Sie die Inhaberschaft der Website (Analysen verifizierter Websites hängen nicht davon ab) oder erlauben Sie SiteNormaBot in dieser Datei.',
    limited:
      'Die Website hat die Anfragen von SiteNorma auf {{count}} Seite(n) begrenzt: Sie wurden nicht analysiert und zählen nicht in der Schätzung. Das ist kein Problem der Website.',
    partial:
      'Auf {{count}} Seite(n) hat die Website die Anfragen begrenzt: Die Analyse lief mit der geladenen Seite, aber der Screenshot zeigt möglicherweise Bilder, die nicht geladen wurden. Diese Ablehnungen zählen wir nicht als Probleme.',
    details: 'Vollständigen Bericht ansehen',
    history: 'Frühere Analysen',
    historyItem: '{{date}} · {{type}}',
    estimate: 'Automatische Schätzung der Barrierefreiheit',
    bands: {
      excelente: 'Ausgezeichnet',
      bueno: 'Gut',
      mejorable: 'Verbesserungswürdig',
      deficiente: 'Mangelhaft',
      'revision-pendiente': 'Manuelle Prüfung ausstehend',
      'sin-datos': 'Keine Daten',
    },
    modules: {
      seo: 'SEO',
      quality: 'Qualität',
    },
    allPages: 'Alle {{count}} Seiten ansehen',
    pagesHeading: 'Analysierte Seiten',
    about: 'Über diese Analyse',
    seeAllProblems: 'Probleme ansehen',
    trend: 'Entwicklung der Schätzung',
    historyScore: 'Schätzung: {{score}}/100',
  },
  scan: {
    title: 'Analyse vom {{date}}',
    technical: 'Technische Details',
    back: 'Zurück zu Analysen',
    pageBlocked: 'Blockiert: {{reason}}',
    pageError: 'Mit Fehler: {{error}}',
    issuesTitle: 'Probleme',
    groups: {
      violations: 'WCAG-Probleme',
      review: 'Manuelle Prüfung erforderlich',
      bestPractices: 'Best Practices',
      seo: 'SEO',
      quality: 'Qualität',
    },
    empty: 'Keine.',
    severity: {
      critica: 'Kritisch',
      grave: 'Schwerwiegend',
      moderada: 'Mäßig',
      leve: 'Gering',
    },
    criteria: 'WCAG {{list}}',
    devices: {
      escritorio: 'Desktop',
      movil: 'Mobilgerät',
    },
    where: 'Auf {{pages}} Seite(n) · {{nodes}} Element(en) · {{devices}}',
    fix: 'So beheben Sie es',
    examples: 'Beispiele',
    exampleOn: 'Auf {{url}} ({{device}})',
    engineScore:
      'Ohne die Erkennungen, die Ihr Team mit Begründung verworfen hat. Die Engine hat {{score}}/100 ergeben.',
    discardedNote_one: '{{count}} mit Begründung verworfene Erkennung zählt nicht mit.',
    discardedNote_other: '{{count}} mit Begründung verworfene Erkennungen zählen nicht mit.',
    discardedMethod: 'So werden verworfene Erkennungen berücksichtigt',
    groupCount_one: '({{count}} Problem · {{rules}} Regel)',
    groupCount_other: '({{count}} Probleme · {{rules}} Regeln)',
    rule: {
      variant: 'Variante {{index}} von {{total}}',
      where: 'Auf {{pages}} Seite(n) · {{nodes}} Element(en)',
      wherePages: 'Auf {{pages}} Seite(n)',
      onPage_one: '{{count}} Element auf dieser Seite',
      onPage_other: '{{count}} Elemente auf dieser Seite',
      onPageAtLeast_one: 'Mindestens {{count}} Element auf dieser Seite',
      onPageAtLeast_other: 'Mindestens {{count}} Elemente auf dieser Seite',
      elsewhere_one: 'auch auf {{count}} weiteren Seite',
      elsewhere_other: 'auch auf {{count}} weiteren Seiten',
      thisPageAndMore_one: 'Auf dieser Seite und auf {{count}} weiteren',
      thisPageAndMore_other: 'Auf dieser Seite und auf {{count}} weiteren',
      thisPage: 'Auf dieser Seite',
      variants_one: '{{count}} Variante',
      variants_other: '{{count}} Varianten',
    },
    elementsOnPage_one: 'Sein Element auf dieser Seite',
    elementsOnPage_other: 'Seine {{count}} Elemente auf dieser Seite',
    charts: {
      severity: 'Probleme nach Schweregrad',
      principles: 'Probleme nach WCAG-Prinzip',
      top: 'Die häufigsten Probleme',
      topHint: 'Anzahl der Seiten, auf denen jedes Problem vorkommt.',
      pageSeverity: 'Probleme auf dieser Seite',
    },
    principles: {
      '1': 'Wahrnehmbar',
      '2': 'Bedienbar',
      '3': 'Verständlich',
      '4': 'Robust',
    },
    map: {
      title: 'Seitenübersicht',
      hint: 'Jede Seite mit ihrem Screenshot, in der Farbe ihres schwersten Problemes. Wählen Sie sie aus, um ihre Daten zu sehen.',
      noCaptures:
        'Die Screenshots dieser Analyse sind nicht mehr verfügbar: Es werden nur die der letzten zwei Analysen jeder Website gespeichert.',
    },
    filters: {
      severity: 'Nach Schweregrad filtern',
      search: 'Nach einem Problem suchen',
      results_one: '{{count}} Problem',
      results_other: '{{count}} Probleme',
    },
    pages: {
      empty: 'Es gibt noch keine analysierten Seiten. Beginnen Sie mit einer Analyse unter „Analysen“.',
      notReady: 'Diese Analyse ist noch nicht abgeschlossen: Ihre Seiten erscheinen, sobald sie fertig ist.',
      failed:
        'Diese Analyse konnte nicht abgeschlossen werden, daher gibt es keine analysierten Seiten anzuzeigen.',
      none: 'Diese Analyse hat keine Seiten.',
      list: 'Seiten der Analyse',
      sort: {
        label: 'Seiten sortieren',
        prioridad: 'Nach Priorität',
        nombre: 'Nach Name',
        pendientes: 'Nach offenen Problemen',
        fecha: 'Nach Datum der letzten Analyse',
      },
      search: 'Seite suchen',
      found: 'Gefundene Seiten: {{count}}',
      newTab: '(öffnet sich in einem neuen Tab)',
      elements_one: '{{count}} betroffenes Element',
      elements_other: '{{count}} betroffene Elemente',
      review_one: '{{count}} zu prüfen',
      review_other: '{{count}} zu prüfen',
      issues_one: 'Probleme dieser Seite ({{count}})',
      issues_other: 'Probleme dieser Seite ({{count}})',
      issuesHint:
        'Nach Regel gruppiert. Öffnen Sie eines, um zu sehen, wie Sie es beheben, und seine Elemente; „Markieren“ kennzeichnet sie im Screenshot.',
      clean:
        'Wir haben auf dieser Seite keine Probleme erkannt. Automatische Tests prüfen nicht alles: Die manuelle Prüfung steht noch aus.',
    },
    facts: {
      status: 'Antwort',
      load: 'Laden',
      ttfb: 'Erstes Byte',
      bytes: 'Größe',
      requests: 'Anfragen',
      lang: 'Sprache',
      features: 'Enthält: {{list}}.',
    },
    features: {
      forms: 'Formulare',
      video: 'Video',
      audio: 'Audio',
      iframes: 'iframes',
    },
    pageBlockedShort: 'Blockiert',
    pageErrorShort: 'Mit Fehler',
    elementOn: 'Element {{number}} ({{device}})',
  },
  viz: {
    ring: {
      none: 'Keine Schätzung: Es konnte keine Seite analysiert werden.',
      pendingHint:
        'Die {{pending}} ausstehenden Punkte kommen nach der manuellen Prüfung dazu. Bis dahin kann die Schätzung {{max}} von 100 nicht überschreiten.',
      full: 'Automatische Schätzung: {{score}} von 100. {{earned}} erreicht, {{lost}} verloren und {{pending}} ausstehende manuelle Prüfung.',
      short: 'Automatische Schätzung: {{score}} von 100.',
      parts: {
        earned: 'Punkte erzielt',
        lost: 'Verloren',
        manual: 'Manuelle Prüfung',
        pending: 'Ausstehend aus der manuellen Prüfung',
      },
    },
    points_one: '{{count}} Punkt',
    points_other: '{{count}} Punkte',
    severities: {
      critica: 'Kritisch',
      grave: 'Schwerwiegend',
      moderada: 'Mäßig',
      leve: 'Gering',
    },
    review: 'Zu prüfen',
    chips: {
      ok: 'Keine Probleme erkannt',
      review_one: '{{count}} zu prüfen',
      review_other: '{{count}} zu prüfen',
      critica_one: '{{count}} kritischer Problem',
      critica_other: '{{count}} kritische Probleme',
      grave_one: '{{count}} schwerwiegender Problem',
      grave_other: '{{count}} schwerwiegende Probleme',
      moderada_one: '{{count}} mäßiger Problem',
      moderada_other: '{{count}} mäßige Probleme',
      leve_one: '{{count}} geringer Problem',
      leve_other: '{{count}} geringe Probleme',
    },
    module: {
      label: '{{label}}: {{score}} von 100',
      none: '{{label}}: keine Daten',
    },
    trend: {
      label_one: 'Entwicklung der Schätzung über {{count}} Analyse: {{to}} ({{end}}).',
      label_other:
        'Entwicklung der Schätzung über {{count}} Analysen: von {{from}} ({{start}}) auf {{to}} ({{end}}).',
    },
  },
  live: {
    mosaic: 'Seiten der Analyse',
    analysing: 'Wird analysiert …',
    analysed: 'Analysiert',
    waiting: 'In der Warteschlange',
    moreWaiting_one: 'und {{count}} weitere in der Warteschlange',
    moreWaiting_other: 'und {{count}} weitere in der Warteschlange',
    blocked: 'Blockiert',
    error: 'Mit Fehler',
  },
  results: {
    backToResults: 'Zurück zu den Ergebnissen der Analyse',
    backToPages: 'Zurück zu allen Seiten',
    summaries: 'Zusammenfassungen der Analyse',
    pagesCount_one: '{{count}} Seite',
    pagesCount_other: '{{count}} Seiten',
    priority: {
      alta: 'Hohe Priorität',
      media: 'Mittlere Priorität',
      baja: 'Niedrige Priorität',
      pendiente: 'Priorität: noch zu prüfen',
    },
    priorityWhy: {
      alta: 'Kann manche Menschen daran hindern, diesen Teil der Website zu nutzen.',
      media:
        'Erschwert manchen Menschen die Nutzung, auch wenn es meist einen anderen Weg gibt, weiterzumachen.',
      baja: 'Eine kleine Störung oder eine empfehlenswerte Verbesserung.',
      pendiente:
        'Die automatische Analyse konnte nicht entscheiden, ob es ein Problem ist: Eine Person muss es prüfen.',
    },
    priorityWhyOther: {
      alta: 'Das ist wichtig für das Funktionieren oder die Auffindbarkeit der Website. Es ist kein Barrierefreiheitsproblem.',
      media: 'Es lohnt sich, das zu beheben, ist aber nicht dringend. Es ist kein Barrierefreiheitsproblem.',
      baja: 'Das ist eine kleine Verbesserung. Es ist kein Barrierefreiheitsproblem.',
    },
    priorityWhyPractice: {
      alta: 'Das ist eine wichtige bewährte Praktik für Menschen mit Hilfstechnologien, auch wenn es kein direkter WCAG-Verstoß ist.',
      media: 'Das ist eine empfehlenswerte bewährte Praktik, auch wenn es kein direkter WCAG-Verstoß ist.',
      baja: 'Das ist eine kleine Verbesserung einer bewährten Praktik, kein WCAG-Verstoß.',
    },
    why: 'Warum:',
    affects: 'Betrifft vor allem Menschen mit: {{who}}.',
    origin: {
      automatic: 'Automatisch erkannt',
      review: 'Automatische Erkennung · manuelle Prüfung erforderlich',
      manual: 'Bei einer manuellen Prüfung erkannt',
    },
    actions: {
      fix: 'Ansehen und beheben',
      check: 'Ansehen und prüfen',
    },
    card: {
      elements_one: '{{count}} betroffenes Element',
      elements_other: '{{count}} betroffene Elemente',
      elementsAtLeast_one: '{{count}}+ betroffene Elemente',
      elementsAtLeast_other: '{{count}}+ betroffene Elemente',
      review_one: '{{count}} Element zu prüfen',
      review_other: '{{count}} Elemente zu prüfen',
      reviewAtLeast_one: '{{count}}+ Elemente zu prüfen',
      reviewAtLeast_other: '{{count}}+ Elemente zu prüfen',
    },
    more: {
      title: 'Weitere Prüfungen',
      show: 'Anzeigen',
    },
    issue: {
      problem: 'Problem',
      noPageData: 'Für dieses Problem gibt es keine Daten dieser Seite.',
      pageOf_one: 'Betroffene Seite',
      pageOf_other: 'Betrifft {{count}} Seiten: Wählen Sie eine',
      fix: 'So beheben Sie es',
      check: 'So prüfen Sie es',
      wcag: 'WCAG-Referenz',
      elements: 'Betroffene Elemente',
      pages: 'Betroffene Seiten',
      technical: 'Technische Details',
      moreElements: 'Und {{count}} weitere Elemente. Sie finden sie auf den betroffenen Seiten.',
      seeInPage: 'Auf der Seite ansehen',
      sharedOne: 'Dieses Problem betrifft {{pages}} Seiten und liegt in einer geteilten Komponente.',
      sharedMany:
        'Dieses Problem betrifft {{pages}} Seiten und liegt in {{components}} geteilten Komponenten.',
      seePages_one: 'Betroffene Seite ansehen',
      seePages_other: 'Die {{count}} betroffenen Seiten ansehen',
      sharedSelector: 'Selektor der geteilten Komponente',
      area: 'Bereich',
      severity: 'Schweregrad',
      type: 'Typ',
      showing: '{{shown}} von {{total}} angezeigt',
      areas: { todas: 'Alle', bestPractices: 'Best Practices', seo: 'SEO', quality: 'Qualität' },
      tracking: {
        title: 'Verfolgung dieses Problems',
        hint: 'Arbeit, Validierung und Überprüfung',
        none: 'Nicht verfolgt',
        validation: 'Bestätigt: {{confirmed}} · Verworfen: {{discarded}}',
        noDecisions: 'Keine Entscheidungen',
        verificationTitle: 'Überprüfung der Korrektur',
        verification: 'Überprüft: {{verified}} · Weiterhin erkannt: {{persists}} · Ausstehend: {{pending}}',
      },
    },
    shared: {
      chip: 'Globales Problem',
      title: 'Geteilte Elemente',
      intro:
        'Dasselbe Element mit derselben Struktur erscheint auf mehreren Seiten: Ursache ist eine geteilte Komponente (Kopfzeile, Fußzeile, Menü, Formular …). Es ist ein einziges Problem, das an einer Stelle verwaltet und einmal behoben wird.',
      zone: 'In {{zone}}',
      pages_one: 'Auf {{count}} Seite',
      pages_other: 'Auf {{count}} Seiten',
      identical: 'Der Code ist überall identisch.',
      textChanges:
        'Gleiche Struktur; Text oder Adressen ändern sich zwischen den Seiten (zum Beispiel zwischen Sprachen).',
      seePages: 'Seiten ansehen',
      separately:
        'Es wird an einer Stelle verfolgt und behoben: Was Sie erfassen, gilt für alle Seiten, aber jede gilt erst als überprüft, wenn eine neue Analyse es dort nicht mehr findet.',
      owner: 'Verwaltet über {{page}}',
      ownerGlobal: 'Verwaltet im Bereich der globalen Probleme',
      elementIn_other: 'Element auf {{count}} Seiten geteilt',
      alsoHere_one:
        'Ein weiteres globales Problem betrifft auch diese Seite; es wird an anderer Stelle verwaltet.',
      alsoHere_other:
        '{{count}} globale Probleme betreffen auch diese Seite; sie werden an anderer Stelle verwaltet.',
    },
    globals: {
      title: 'Globale Probleme',
      intro:
        'Sie betreffen Elemente, die mehrere Seiten teilen (Kopfzeile, Fußzeile, Menü …). Sie werden nur einmal angezeigt und an einer Stelle verwaltet.',
      manage: 'Ansehen und verwalten',
      where: 'Verwaltet auf {{page}}',
      whereGlobal: 'Die Startseite hat es nicht: verwaltet auf {{page}}',
    },
    counts: {
      pageOnly: 'Betrifft diese Seite',
      pagesOnly: 'Betrifft {{pages}}',
      elementsOnly_one: '{{count}} Element',
      elementsOnly_other: '{{count}} Elemente',
      elementsOnlyAtLeast_one: 'mindestens {{count}} Element',
      elementsOnlyAtLeast_other: 'mindestens {{count}} Elemente',
      affectsPage: 'betrifft die Seite',
      languages_one: '{{count}} Sprache: {{list}}',
      languages_other: '{{count}} Sprachen: {{list}}',
    },
    devices: {
      both: 'auf Desktop und Mobilgerät',
      desktop: 'nur auf dem Desktop',
      mobile: 'nur auf dem Mobilgerät',
    },
    manual: {
      figures: { registered: 'Geprüft', pending: 'Offen', decide: 'Zu entscheiden' },
      open: 'Manuelle Prüfungen ansehen',
      title: 'Manuelle Prüfungen',
      progress: '{{done}} von {{total}} Kriterien mit mindestens einer festgehaltenen Prüfung',
      pending_one: '{{count}} Kriterium wartet auf manuelle Prüfung.',
      pending_other: '{{count}} Kriterien warten auf manuelle Prüfung.',
      itemsDecided:
        'Von {{total}} Elementen, die die Analyse nicht entscheiden konnte, hat Ihr Team {{decided}} bestätigt oder verworfen.',
      hint: 'Automatische Tests ersetzen die manuelle Prüfung nicht: Kein Kriterium gilt als erfüllt, bevor eine Person es geprüft hat.',
      intro:
        'Die manuelle Prüfung kontrolliert Kriterium für Kriterium, was kein automatisches Werkzeug entscheiden kann. Diese Liste enthält die Kriterien der Norm Ihrer Website und zeigt, wo jedes steht: Das Ergebnis der automatischen Analyse und das der manuellen Prüfung werden getrennt geführt.',
      status: {
        incumple: 'Nicht erfüllt (erkannt)',
        'sin-incidencias': 'Keine automatischen Probleme: manuelle Prüfung erforderlich',
        pendiente: 'Manuelle Prüfung ausstehend',
      },
      statusHelp: {
        incumple:
          'Die automatische Analyse hat mindestens ein Problem gefunden, das dieses Kriterium betrifft.',
        'sin-incidencias':
          'Die zutreffenden automatischen Prüfungen haben keine Fehler gefunden, aber das reicht nicht: Es muss von Hand geprüft werden.',
        pendiente:
          'Kein automatischer Test hat es auf diesen Seiten geprüft, oder es lässt sich nicht mit automatischen Werkzeugen prüfen.',
      },
      toReview_one: '{{count}} Aspekt von Hand zu entscheiden',
      toReview_other: '{{count}} Aspekte von Hand zu entscheiden',
    },
    summary: {
      globalProblems_one: '1 betrifft mehrere Seiten',
      globalProblems_other: '{{count}} betreffen mehrere Seiten',
      title: 'Zusammenfassung',
      priority: 'Priorität',
      priorities: {
        alta: '{{count}} mit hoher Priorität',
        media: '{{count}} mit mittlerer Priorität',
        baja: '{{count}} mit niedriger Priorität',
      },
      problems: 'Problemtypen',
      problemsHelp: 'Was ein Problemtyp ist',
      problemsHelpText:
        'Eine Art von Fehler, auch wenn sie sich auf mehreren Seiten oder Elementen wiederholt.',
      elements: 'Betroffene Elemente',
      elementsHelp: 'Was ein betroffenes Element ist',
      elementsHelpText:
        'Ein Bild, eine Schaltfläche oder ein anderes Element mit Fehlern. Schlägt es auf Desktop und Mobilgerät fehl, zählt es einmal.',
      atLeast: 'Mindestens',
      pages: 'Seiten mit Problemen',
      sharedElements: '{{count}} wiederholen sich auf anderen Seiten',
      pagesOfTotal: '{{count}} von {{total}} analysiert',
      repeated:
        'Dasselbe Element kann bei mehreren Problemtypen fehlschlagen und wird in der Gesamtzahl nur einmal gezählt. Deshalb ergibt die Summe {{summed}} und die Gesamtzahl ist {{total}}.',
      none_one: 'Auf der analysierten Seite wurden keine automatischen Probleme erkannt.',
      none_other: 'Auf den {{count}} analysierten Seiten wurden keine automatischen Probleme erkannt.',
      how: {
        title: 'Wie diese Zahlen gezählt werden',
        problem: {
          term: 'Problemtyp',
          text: 'Eine Art von Fehler (zum Beispiel „Bild ohne Alternativtext“), auch wenn sie sich wiederholt.',
        },
        element: {
          term: 'Betroffenes Element',
          text: 'Ein Bild, eine Schaltfläche oder ein anderes Element mit Fehlern. Schlägt es auf Desktop und Mobilgerät fehl, zählt es einmal.',
        },
        atLeast: {
          term: 'Das „+“-Zeichen',
          text: 'Die Analyse hört auf zu zählen, wenn eine Seite sehr viele Elemente hat; die tatsächliche Summe kann höher sein.',
        },
        appearance: {
          term: 'Vorkommen',
          text: 'Jedes Mal, wenn eine Prüfung ein Element findet (pro Gerät). Sichtbar in den technischen Details.',
        },
        devices: {
          term: 'Geräte',
          text: 'Die Zahlen addieren Desktop und Mobilgerät, sofern ein Filter nichts anderes sagt.',
        },
        pages: {
          term: 'Seiten mit Problemen',
          text: 'Seiten dieser Analyse mit mindestens einem Problemtyp. Der Reiter „Seiten“ listet alle jemals analysierten Seiten.',
        },
        pageCount: {
          term: 'Die Zahl auf jeder Seite',
          text: 'Verschiedene Problemtypen auf dieser Seite. Die Summe der Seiten kann höher sein als die Gesamtzahl der Analyse.',
        },
        repeated: {
          term: 'Ein Element in mehreren Typen',
        },
      },
    },
    pageSummary: {
      global_one: 'davon 1 global',
      global_other: 'davon {{count}} global',
      title: 'Zusammenfassung dieser Seite',
      none: 'Die automatische Analyse hat auf dieser Seite keine Barrierefreiheitsprobleme erkannt. Das bedeutet nicht, dass sie vollständig barrierefrei ist.',
      problems_one: '{{count}} Problem erkannt',
      problems_other: '{{count}} Probleme erkannt',
      elements_one: '{{count}}{{plus}} betroffenes Element',
      elements_other: '{{count}}{{plus}} betroffene Elemente',
      priorities: {
        alta: 'Hohe Priorität: {{count}}',
        media: 'Mittlere Priorität: {{count}}',
        baja: 'Niedrige Priorität: {{count}}',
      },
    },
    start: {
      title: 'Womit Sie beginnen sollten',
      intro:
        'Beginnen Sie mit diesen Problemen: Sie haben die höchste Priorität und betreffen bei gleicher Priorität die meisten Elemente und Seiten.',
      counts_one: '{{count}} betroffenes Element auf {{pages}}',
      counts_other: '{{count}} betroffene Elemente auf {{pages}}',
      countsAtLeast_one: 'Mindestens {{count}} betroffenes Element auf {{pages}}',
      countsAtLeast_other: 'Mindestens {{count}} betroffene Elemente auf {{pages}}',
      how: {
        title: 'Wie wird die Priorität bestimmt?',
        intro:
          'Die Priorität zeigt, wie sehr ein Problem die Nutzung der Website erschwert, je nach der Auswirkung, die der Test erkennt. Sie misst nicht das rechtliche Risiko.',
        alta: 'Kann jemanden daran hindern, eine Aufgabe abzuschließen (zum Beispiel eine Schaltfläche, die der Screenreader nicht ansagen kann).',
        media: 'Erschwert die Nutzung, aber meist gibt es einen anderen Weg, weiterzumachen.',
        baja: 'Eine kleine Störung oder eine empfehlenswerte Verbesserung.',
        pendiente: 'Die Analyse kann nicht entscheiden, ob es ein Problem ist: Eine Person muss es prüfen.',
        order:
          'Innerhalb jeder Priorität stehen zuerst die Probleme, die mehr Elemente betreffen, danach die, die mehr Seiten betreffen, und zuletzt kommt die alphabetische Reihenfolge.',
      },
    },
    score: {
      title: 'Automatische Schätzung',
      value: '{{score}}/100',
      intro: 'Von 0 bis 100 Punkten. Kein WCAG-Erfüllungsprozentsatz und keine rechtliche Konformität.',
      method: 'So wird sie berechnet',
    },
    honesty: {
      text: 'Die automatische Analyse erkennt nur einen Teil der Probleme. Manches braucht eine manuelle Prüfung.',
      link: 'So analysieren wir Ihre Website',
    },
    pageCard: {
      onlyGlobal_one: '{{count}} globales Problem',
      onlyGlobal_other: '{{count}} globale Probleme',
      languages: 'Sprachversionen',
      showLanguage: 'Version auf {{language}} ansehen',
      problems_one: '{{count}} Problem',
      problems_other: '{{count}} Probleme',
      none: 'Keine Probleme erkannt',
      noneShort: 'Keine Probleme',
    },
    context: {
      label: 'Was analysiert wurde',
      date: 'Analyse vom {{date}}',
      devices: 'Geräte: Desktop und Mobilgerät',
      complete: 'Abgeschlossene Analyse',
      partial_one: 'Teilweise abgeschlossene Analyse: Noch {{count}} Seite zu analysieren',
      partial_other: 'Teilweise abgeschlossene Analyse: Noch {{count}} Seiten zu analysieren',
      previous: 'Früheres Ergebnis',
    },
    previous: {
      title: 'Dies ist ein früheres Ergebnis.',
      text: 'Es gibt eine neuere Analyse vom {{date}}.',
      link: 'Neueste Analyse ansehen',
    },
    tabs: {
      label: 'Ergebniskategorien',
      problems: 'Erkannte Probleme',
      passed: 'Prüfungen ohne erkannte Probleme',
      unchecked: 'Aspekte, die nicht geprüft werden konnten',
      manual: 'Manuelle Prüfungen',
      other: 'Best Practices, SEO und Qualität',
    },
    problems: {
      none: {
        scan: 'Die automatische Analyse hat auf den analysierten Seiten keine Barrierefreiheitsprobleme erkannt. Das bedeutet nicht, dass die Website vollständig barrierefrei ist: Die manuellen Prüfungen fehlen noch.',
        page: 'Die automatische Analyse hat auf dieser Seite keine Barrierefreiheitsprobleme erkannt. Das bedeutet nicht, dass sie vollständig barrierefrei ist: Die manuellen Prüfungen fehlen noch.',
      },
    },
    passed: {
      level: 'Stufe {{level}}',
      result: 'Ergebnis:',
      resultPage: 'Die automatische Prüfung hat auf dieser Seite keine Probleme gefunden.',
      resultPages_one: 'Die automatische Prüfung hat auf {{count}} Seite keine Probleme gefunden.',
      resultPages_other: 'Die automatische Prüfung hat auf {{count}} Seiten keine Probleme gefunden.',
      where:
        'Sie betrachtet die ganze Seite: Die Analyse speichert die konkret geprüften Elemente nicht, sie können daher nicht im Screenshot markiert werden. Hier ist nichts zu beheben, und es bedeutet nicht, dass das Kriterium vollständig erfüllt ist: Eine manuelle Prüfung ist nötig.',
      intro: {
        scan: 'Automatische Prüfungen, die auf die analysierten Seiten angewendet wurden und keine Fehler gefunden haben.',
        page: 'Automatische Prüfungen, die auf diese Seite angewendet wurden und keine Fehler gefunden haben.',
      },
      note: 'Dass eine Prüfung keine Fehler findet, heißt nicht, dass das Kriterium erfüllt ist: Automatische Tests erkennen nur einen Teil der Barrieren, und die Kriterien müssen weiterhin manuell geprüft werden.',
      unavailable:
        'Diese Analyse wurde durchgeführt, bevor wir diese Information gespeichert haben. Führen Sie eine neue Analyse durch, um die Prüfungen ohne Probleme zu sehen.',
      none: 'Keine Prüfung blieb ohne Probleme.',
      wcag_one: '{{count}} Prüfung der WCAG-Richtlinien',
      wcag_other: '{{count}} Prüfungen der WCAG-Richtlinien',
      practices_one: '{{count}} Prüfung zu Best Practices',
      practices_other: '{{count}} Prüfungen zu Best Practices',
      inPages_one: 'auf {{count}} Seite',
      inPages_other: 'auf {{count}} Seiten',
    },
    unchecked: {
      intro:
        'Hier steht, was die automatische Analyse nicht entscheiden konnte und was nicht analysiert wurde. Nichts davon gilt als in Ordnung.',
      byHand: 'Von Hand zu entscheiden ({{count}})',
      byHandHint:
        'Die automatische Analyse konnte nicht entscheiden, ob dies ein Problem ist. Eine Person muss es prüfen und kann, wenn sie möchte, ihre Entscheidung festhalten.',
      noneByHand: 'Es gibt keine Aspekte, die noch von Hand zu entscheiden sind.',
      pages: 'Seiten, die nicht analysiert wurden ({{count}})',
      pagesHint: 'Diese Seiten wurden nicht analysiert und gelten daher nicht als bestanden.',
      noPages: 'Alle vorgesehenen Seiten wurden analysiert.',
    },
    other: {
      intro:
        'Prüfungen, die helfen, die Website zu verbessern, aber keine Barrierefreiheitsprobleme nach den WCAG sind.',
      note: 'Best Practices, SEO und technische Qualität zählen nicht in der Zusammenfassung der Barrierefreiheitsprobleme.',
      bestPractices: 'Best Practices für Barrierefreiheit',
      bestPracticesHint:
        'Sie verbessern die Erfahrung mit Hilfstechnologien, verstoßen aber nicht direkt gegen ein WCAG-Kriterium.',
      seo: 'SEO (Sichtbarkeit in Suchmaschinen)',
      seoHint: 'Sie helfen Suchmaschinen, die Website zu finden und zu verstehen.',
      quality: 'Technische Qualität',
      qualityHint: 'Technische Fehler, Sicherheit und Cookies der Seite.',
      empty: 'In diesem Bereich gibt es nichts anzuzeigen.',
    },
    filters: {
      title: 'Filtern',
      priority: 'Priorität',
      device: 'Gerät',
      devices: {
        todos: 'Alle Geräte',
        escritorio: 'Desktop',
        movil: 'Mobilgerät',
      },
      search: 'Nach Name, Erklärung oder WCAG-Kriterium suchen',
      shown: '{{shown}} von {{total}} werden angezeigt.',
      clear: 'Filter entfernen',
      noMatch: 'Nichts passt zu den Filtern. Wählen Sie „Filter entfernen“, um alles zu sehen.',
    },
    detail: {
      title: 'Detaillierte Ergebnisse',
      howToCheck: 'So prüfen Sie es',
      where: 'Wo es sich befindet',
      examples: 'Beispiele für Elemente',
      engineMessage: 'Technische Meldung der Engine',
      elementsHere_one: 'Das Element dieser Seite',
      elementsHere_other: 'Die {{count}} Elemente dieser Seite',
      technical: 'Technische Details',
      rule: 'Regel der Prüf-Engine',
      criteria: 'Zugehörige WCAG-Kriterien',
      criterion: 'WCAG {{id}} {{title}} (Stufe {{level}})',
      appearances: 'Vorkommen',
      appearancesValue_one: '{{count}} Vorkommen',
      appearancesValue_other: '{{count}} Vorkommen',
      appearancesHelp:
        'Jedes Mal, wenn die Prüfung ein Element findet, zählt ein Vorkommen: Dasselbe Element, das auf dem Desktop und auf dem Mobilgerät fehlschlägt, ergibt zwei Vorkommen, ist aber nur ein einziges Element.',
      groups: 'Technische Gruppen',
      groupsValue_one: '{{count}} Gruppe',
      groupsValue_other: '{{count}} Gruppen',
      groupsHelp:
        'Elemente derselben Regel, die gruppiert sind, weil sie vom selben Typ sind und in derselben Seitenstruktur stehen. Diese Beziehung prüft die Engine. Jede Gruppe hat ihre eigene Nachverfolgung.',
      scopeNote: 'Was hier zählt',
      scopeNoteValue: 'Verschiedene Elemente aller analysierten Seiten, Desktop und Mobilgerät zusammen.',
    },
  },
  status: {
    outcomes: {
      queued: 'Analyse in der Warteschlange',
      running: 'Analyse läuft',
      complete: 'Analyse abgeschlossen',
      partial: 'Analyse teilweise abgeschlossen',
      failed: 'Die Analyse konnte nicht abgeschlossen werden',
    },
    announce: {
      queued: 'Analyse in der Warteschlange.',
      running: 'Analyse läuft.',
      complete: 'Analyse abgeschlossen. Sie können die Ergebnisse jetzt ansehen.',
      partial: 'Analyse teilweise abgeschlossen. Prüfen Sie, welche Seiten nicht analysiert wurden.',
      failed: 'Die Analyse konnte nicht abgeschlossen werden.',
      refreshed: 'Status aktualisiert.',
    },
    identity: {
      url: 'Adresse',
      scope: 'Umfang',
      scopeValue_one: '{{mode}} · bis zu {{count}} Seite, auf Desktop und Mobilgerät',
      scopeValue_other: '{{mode}} · bis zu {{count}} Seiten, auf Desktop und Mobilgerät',
      requested: 'Angefordert am',
    },
    modes: {
      pagina: 'Nur die angegebene Seite',
      rapido: 'Schnellanalyse',
      completo: 'Vollständige Analyse',
      personalizado: 'Benutzerdefinierte Analyse',
      comprobacion: 'Prüfung von Korrekturen',
    },
    queued: {
      text: 'Ihre Analyse steht in der Warteschlange. Sie beginnt, sobald Kapazität frei ist.',
    },
    leave:
      'Sie können diesen Bildschirm verlassen. Die Analyse läuft weiter, und Sie können ihren Status in der Website abrufen.',
    progress: 'Analyse von {{done}}/{{total}}',
    progressEta: {
      seconds: 'Noch etwa {{count}} Sekunden',
      minutes_one: 'Noch etwa {{count}} Minute',
      minutes_other: 'Noch etwa {{count}} Minuten',
    },
    phases: {
      title: 'Phasen der Analyse',
      queued: 'In der Warteschlange',
      preparing: 'Analyse wird vorbereitet',
      analysing: 'Seiten werden analysiert',
      finishing: 'Einschätzung wird berechnet',
      done: 'abgeschlossen',
      current: 'aktuelle Phase',
    },
    refresh: {
      failed: 'Wir konnten den Status nicht aktualisieren. Versuchen Sie es erneut.',
      action: 'Status aktualisieren',
      lastKnown: 'Letzter empfangener Status um {{time}}. Die Analyse wurde dadurch nicht gestoppt.',
    },
    partial: {
      text: '{{done}} von {{total}} Seiten analysiert.',
      pending_one: '1 Seite fehlt: Sie gilt nicht als bestanden.',
      pending_other: '{{count}} Seiten fehlen: Sie gelten nicht als bestanden.',
      why: 'Die Analyse konnte nicht vollständig abgeschlossen werden: mindestens eine Seite wurde nicht analysiert (zum Beispiel wegen Zeitüberschreitung). Unten steht jede mit dem Grund.',
      next: 'Starten Sie die Analyse erneut, um die fehlenden Seiten zu erfassen.',
      nextFull:
        'Dieses Ergebnis zählt nicht als gültige vollständige Analyse. Starten Sie erneut eine vollständige Analyse.',
      nextFullComplete:
        'Dieses Ergebnis zählt nicht als gültige vollständige Analyse. Sie können nur die ausstehenden Seiten vervollständigen: Diese werden erneut analysiert und die bereits gelungenen bleiben erhalten. Nur die erneut analysierten Seiten zählen für Ihr Kontingent.',
      complete_one: '1 ausstehende Seite vervollständigen',
      complete_other: '{{count}} ausstehende Seiten vervollständigen',
      completing: 'Analyse wird vervollständigt…',
      completeFailed:
        'Wir konnten die Analyse nicht vervollständigen. Es wurde keine Seite verbraucht: Sie können es erneut versuchen.',
    },
    pending: {
      title: 'Nicht analysierte Seiten',
      hint: 'Sie wurden nicht analysiert und zählen nicht als bestanden.',
      more: 'Und {{count}} weitere.',
    },
    causes: {
      interrupted: 'Die Analyse wurde vor dem Ende unterbrochen und hat keine Ergebnisse hinterlassen.',
      domain:
        'Die Domain der Website lässt sich keiner öffentlichen Adresse zuordnen. Prüfen Sie, ob die Adresse stimmt und die Website online ist.',
      limited:
        'Die Website hat automatische Anfragen begrenzt (HTTP 429), und keine Seite konnte analysiert werden. Das ist kein Mangel Ihrer Website.',
      blocked:
        'Die Website hat die automatische Analyse blockiert, und keine Seite konnte analysiert werden.',
      unreachable: 'Keine Seite der Website konnte geladen werden.',
      unknown: 'Die genaue Ursache ist uns nicht bekannt.',
      technical: 'Technische Details',
    },
    consumption: {
      reserved_one:
        'Solange sie läuft, wird bis zu {{count}} Seite Ihres Guthabens reserviert. Am Ende werden nur die analysierten Seiten gezählt.',
      reserved_other:
        'Solange sie läuft, werden bis zu {{count}} Seiten Ihres Guthabens reserviert. Am Ende werden nur die analysierten Seiten gezählt.',
      used_one: 'Verbrauch dieser Analyse: {{count}} Seite.',
      used_other: 'Verbrauch dieser Analyse: {{count}} Seiten.',
      none: 'Verbrauch dieser Analyse: keine Seite.',
      notCounted_one: 'Die nicht analysierte Seite wurde nicht gezählt.',
      notCounted_other: 'Die {{count}} nicht analysierten Seiten wurden nicht gezählt.',
    },
    actions: {
      settings: 'Einstellungen prüfen',
      prepare: 'Neue Analyse',
      previousResults: 'Ergebnisse dieser Analyse ansehen',
      seeResults: 'Ergebnisse ansehen',
    },
  },
  compare: {
    title: 'Im Vergleich zur Analyse vom {{date}}',
    same: 'Gleiche Schätzung',
    points_one: '{{signed}} Punkt',
    points_other: '{{signed}} Punkte',
    resolved_one: '{{count}} Problem behoben',
    resolved_other: '{{count}} Probleme behoben',
    new_one: '{{count}} neues Problem',
    new_other: '{{count}} neue Probleme',
  },
  check: {
    title: 'Letzte Überprüfung von Korrekturen',
    titleNote: 'Keine Analyse der ganzen Website',
    scope:
      'Eine Überprüfung analysiert nur die Seiten der überprüften Elemente: Sie ist keine Analyse der ganzen Website, berechnet also keine Schätzung und wird nicht mit früheren Analysen verglichen.',
    looked: 'Überprüft: {{elements}} auf {{pages}}.',
    elementsCount_one: '{{count}} Element',
    elementsCount_other: '{{count}} Elemente',
    pagesCount_one: '{{count}} Seite',
    pagesCount_other: '{{count}} Seiten',
    pending: 'Nicht automatisch bestätigt',
    summaryPending_one:
      '{{count}} Element konnte nicht automatisch bestätigt werden. Sein Selektor schlägt nicht mehr fehl, aber eine manuelle Prüfung ist nötig.',
    summaryPending_other:
      '{{count}} Elemente konnten nicht automatisch bestätigt werden. Ihre Selektoren schlagen nicht mehr fehl, aber eine manuelle Prüfung ist nötig.',
    summaryPossibleChange_one:
      'Das Element schlägt mit seinem ursprünglichen Selektor nicht mehr fehl, aber die Seite hat noch andere Fehler derselben Art. Die Analyse kann nicht sicher sein, dass es dasselbe Element ist: prüfen Sie es von Hand.',
    summaryPossibleChange_other:
      '{{count}} Elemente schlagen mit ihrem ursprünglichen Selektor nicht mehr fehl, aber die Seite hat noch andere Fehler derselben Art. Die Analyse kann nicht sicher sein, dass es dieselben sind: prüfen Sie sie von Hand.',
    summaryPersists_one: '{{count}} Element wird nach der Überprüfung weiterhin erkannt.',
    summaryPersists_other: '{{count}} Elemente werden nach der Überprüfung weiterhin erkannt.',
    summaryVerified: 'Die überprüften Elemente werden in dieser Überprüfung nicht mehr erkannt.',
    summaryMixed:
      '{{verified}} nicht erkannt · {{persists}} weiterhin erkannt · {{pending}} nicht automatisch bestätigt.',
    nextPending: 'In der Nachverfolgung prüfen',
    nextPersists: 'Zur Nachverfolgung',
    nextVerified: 'Zur Nachverfolgung',
    details: 'Detail zu jedem Element ansehen',
    seeResults: 'Überprüfte Seiten ansehen',
    seeFollow: 'Zur Nachverfolgung',
  },
  figures: {
    pages: 'Analysierte Seiten',
    failures: 'WCAG-Probleme',
    elements: 'Betroffene Elemente',
    review: 'Manuelle Prüfung erforderlich',
  },
  inspector: {
    title: 'Screenshot der Seite',
    device: 'Gerät des Screenshots',
    devices: {
      escritorio: 'Desktop',
      movil: 'Mobilgerät',
    },
    frame: 'Screenshot der Seite (lässt sich verschieben und vergrößern)',
    alt: 'Screenshot von {{page}} ({{device}})',
    zoom: { label: 'Aufnahme vergrößern', enlarge: 'Vergrößern' },
    reload: 'Aufnahme neu laden',
    loading: 'Screenshot wird geladen …',
    loadError:
      'Der Screenshot konnte nicht geladen werden. Elemente werden erst markiert, wenn er angezeigt wird.',
    retry: 'Erneut versuchen',
    panHint:
      'Ziehen Sie den Screenshot, um ihn zu verschieben, oder fokussieren Sie ihn und nutzen Sie die Pfeiltasten.',
    notLocated: {
      'no-capture':
        'Für dieses Gerät gibt es keinen Screenshot, daher kann das Element nicht markiert werden.',
      'no-position':
        'Dieses Element konnte nicht auf dem Screenshot platziert werden (es kann in einem Frame, verborgen oder außerhalb des sichtbaren Bereichs liegen). Sein Selektor steht unter „Technische Lösung ansehen“.',
      outside:
        'Dieses Element liegt außerhalb des Teils der Seite, der im Screenshot erfasst wurde. Sehen Sie sich seine Beschreibung in der Anleitung an.',
      'other-device':
        'Dieses Element wurde auf diesem Gerät nicht erkannt. Wechseln Sie das Gerät, um es markiert zu sehen.',
    },
    noCapture: 'Für diese Seite gibt es auf diesem Gerät keinen Screenshot.',
    expired:
      'Der Screenshot ist nicht mehr verfügbar: Es werden nur die der letzten beiden Analysen jeder Website gespeichert.',
  },
  element: {
    guideTitle: 'Anleitung für {{name}}',
    shared: {
      title_one: 'Dieses Element ist auf {{count}} Seite geteilt',
      title_other: 'Dieses Element ist auf {{count}} Seiten geteilt',
      here: 'Es wird über diese Seite verwaltet. Was Sie hier erfassen, gilt für alle {{count}} Seiten.',
      there:
        'Es wird über {{page}} verwaltet. Was Sie hier erfassen, gilt ebenfalls für alle {{count}} Seiten.',
      open: 'Auf {{page}} öffnen',
      identical: 'Der Code ist überall identisch.',
      textChanges:
        'Gleiche Struktur; Text oder Adressen ändern sich zwischen den Seiten (zum Beispiel zwischen Sprachen).',
      progress: {
        'sin-aplicar': 'Korrektur auf keiner Seite angewendet.',
        'aplicada-en-parte': 'Korrektur nur auf einem Teil der Seiten angewendet.',
        aplicada: 'Korrektur auf allen Seiten angewendet: Sie muss noch überprüft werden.',
        'verificada-en-parte':
          'Korrektur nur auf einem Teil der Seiten überprüft: Das Problem gilt nicht als gelöst.',
        verificada: 'Korrektur auf allen Seiten überprüft.',
      },
      separately:
        'Als angewendet markieren überprüft die Korrektur nicht: Nur eine neue Analyse oder eine manuelle Prüfung bestätigt sie.',
    },
    panel: {
      back: 'Alle Probleme',
      problem: 'Problem',
      solution: 'Lösung',
      showWhere: 'Ansehen, wo es ist',
      backToSolution: 'Zurück zur Lösung',
      captureTitle: 'Wo das Element ist',
      element: 'Betroffenes Element',
      verifyAuto: 'Nach der Korrektur prüft eine neue Analyse es automatisch.',
      verifyManual:
        'Erfordert eine manuelle Prüfung: Die automatische Analyse kann es nicht entscheiden, eine Person muss es prüfen.',
      technical: 'Technische Lösung ansehen',
      wcag: 'WCAG-Verweise',
      measured: 'Gemessen',
    },
    nav: {
      label: 'Elemente des Problems auf dieser Seite',
      position: 'Element {{index}} von {{total}} auf dieser Seite',
      previous: 'Zurück',
      next: 'Weiter',
      status: 'Element {{index}} von {{total}} auf dieser Seite: {{name}}.',
      sample:
        'Angezeigt werden {{shown}} von {{total}} Elementen: Von den übrigen wird weder gespeichert, wo sie sich befinden, noch ihr Code.',
      analysisTotal_one: '{{count}} in der gesamten Analyse',
      analysisTotal_other: '{{count}} in der gesamten Analyse',
      noElements:
        'Dieses Problem betrifft die ganze Seite, nicht ein einzelnes Element, auf das man zeigen könnte. Folgen Sie den Schritten oben.',
    },
    sections: {
      owner: 'Wer das tun kann',
      check: 'So prüfen Sie es',
    },
    where: {
      positionValue: '{{vertical}} % unterhalb des oberen Seitenrands, {{side}}',
      positionSide: 'Auf der Seite, {{side}}',
      sides: {
        left: 'links',
        center: 'in der Mitte',
        right: 'rechts',
      },
    },
    roles: {
      desarrollo: 'Wer den Code der Website entwickelt oder pflegt',
      diseno: 'Wer die Website gestaltet oder das Layout umsetzt',
      contenido: 'Wer die Inhalte der Website bearbeitet (Texte, Bilder, Links)',
      unknown: 'Wer die Website pflegt',
      note: 'Das hängt von der Art des Problems ab. Wir wissen nicht, wer Ihre Website pflegt und welche Berechtigungen Sie haben: Wenn Sie es nicht selbst tun können, kopieren Sie die Anweisungen für die Person, die es übernimmt.',
    },
    generic: {
      check1: 'Nehmen Sie die Änderung auf Ihrer Website vor und laden Sie die Seite neu.',
      check2: 'Prüfen Sie, ob dieses Element das beschriebene Problem nicht mehr hat.',
      check3:
        'Führen Sie eine neue Analyse der Seite durch, um zu bestätigen, dass SiteNorma das Problem nicht mehr erkennt. Eine Änderung zu kopieren oder anzuwenden bedeutet nicht, dass das Problem behoben ist.',
    },
    proposal: {
      adapted: 'Auf dieses Element zugeschnittener Vorschlag',
      example: 'Beispiel, das angepasst werden muss',
      currentCode: 'Aktueller Code',
      proposedCode: 'Vorgeschlagene Änderung ({{language}})',
      copy: 'Code kopieren',
      copied: 'Code kopiert.',
      failed: 'Das Kopieren war nicht möglich. Markieren Sie den Text und kopieren Sie ihn von Hand.',
      whereKnown: 'Wo Sie es anwenden: {{where}}.',
      whereUnknown:
        'Wir wissen nicht, in welcher Datei oder Vorlage Ihrer Website diese Änderung vorzunehmen ist: Suchen Sie sie oder geben Sie das an die Person weiter, die die Website pflegt.',
      notAGuarantee:
        'Das ist ein Vorschlag, keine sichere Lösung: Solange keine neue Analyse es bestätigt, bleibt das Problem offen.',
    },
    decision: {
      choose: 'Wählen Sie eine Option, um den Vorschlag zu sehen.',
    },
    verify: {
      title: 'Korrektur prüfen',
      text: 'Den Code zu kopieren, eine Änderung anzuwenden oder hier den Status zu ändern bedeutet nicht, dass das Problem behoben ist. Zur Bestätigung ist eine Prüfung nötig: eine neue Analyse (sie verbraucht Seiten Ihres Guthabens und läuft immer zuerst über die Zusammenfassung) oder eine manuelle Prüfung.',
      action: 'Korrektur prüfen',
    },
    technical: {
      selector: 'Selektor',
      location: 'Technische Lokalisierung',
      position: 'Position',
      xpath: 'XPath-Pfad',
      code: 'Aktueller Code',
    },
    copy: {
      action: 'Anweisungen für Entwickler kopieren',
      copied: 'Anweisungen kopiert.',
      failed:
        'Das Kopieren war nicht möglich. Markieren Sie den Text der Anleitung und kopieren Sie ihn von Hand.',
      title: 'SiteNorma · Anweisungen zur Behebung eines Barrierefreiheitsproblems',
      problem: 'Problem',
      what: 'Was passiert',
      where: 'Wo es sich befindet',
      element: 'Element',
      page: 'Seite',
      device: 'Gerät',
      position: 'Ungefähre Position',
      date: 'Datum der Analyse',
      evidence: 'Nachweise',
      how: 'So beheben Sie es',
      currentCode: 'Aktueller Code',
      check: 'So prüfen Sie es',
      selector: 'Selektor',
      note: 'Diese Anweisungen zu kopieren oder die Änderung anzuwenden bedeutet nicht, dass das Problem behoben ist: Nur eine neue Analyse von SiteNorma bestätigt es. Die automatische Analyse erkennt nur einen Teil der Barrieren.',
    },
  },
  manual: {
    title: 'Manuelle Prüfungen',
    intro:
      'Manche Aspekte der Barrierefreiheit müssen von einer Person geprüft werden. Folgen Sie den Anweisungen und halten Sie fest, was Sie geprüft haben.',
    available:
      'Sie können jederzeit eine Prüfung beginnen: Sie müssen nicht warten, bis die Probleme behoben sind, die die automatische Analyse gefunden hat, und eine automatische Analyse ohne Erkennungen schließt eine ausstehende Prüfung nicht ab.',
    notAudit:
      'Eine Anleitung hilft Ihnen, einen Aspekt auf einer Seite zu prüfen. Sie ist keine Bewertung Ihrer gesamten Website, und eine festgehaltene Prüfung bedeutet nicht, dass Ihre Website die Vorschriften einhält.',
    readOnly: 'Ihre Rolle erlaubt es nur, die Prüfungen einzusehen.',
    progress: {
      title: 'Fortschritt der manuellen Prüfung',
      summary: '{{registered}} von {{total}} Kriterien mit mindestens einer festgehaltenen Prüfung',
      text: 'Im Fortschrittsbalken haben {{registered}} von {{total}} Kriterien mindestens eine festgehaltene Prüfung.',
      started_one: '{{count}} weiteres Kriterium hat einen Entwurf, der nicht festgehalten ist.',
      started_other: '{{count}} weitere Kriterien haben einen Entwurf, der nicht festgehalten ist.',
      needNew_one: '{{count}} Prüfung muss wiederholt werden, weil sich die Seite geändert hat.',
      needNew_other: '{{count}} Prüfungen müssen wiederholt werden, weil sich die Seite geändert hat.',
      answers: 'Aktuelle Antworten',
      note: 'Dieser Fortschritt betrifft nur die manuellen Prüfungen: Er wird getrennt von der automatischen Analyse und von der Nachverfolgung der Arbeit geführt. Eine festgehaltene Prüfung bestätigt, dass sie durchgeführt wurde, nicht dass sie bestanden wurde, und die Prüfung eines Kriteriums auf einer Seite sagt nichts über den Rest Ihrer Website aus.',
    },
    state: {
      'no-iniciada': 'Manuelle Prüfung nicht begonnen',
      pendiente: 'Prüfung ausstehend',
      registrada: 'Manuelle Prüfung mit Antwort',
    },
    answer: {
      'sin-problemas': 'Ich habe keine Probleme gefunden',
      problema: 'Ich habe ein Problem gefunden',
      'no-comprobado': 'Ich konnte es nicht prüfen',
      'no-aplica': 'Nicht zutreffend',
    },
    condition: {
      teclado: 'Nur mit der Tastatur',
      'lector-de-pantalla': 'Mit einem Screenreader',
      zoom: 'Mit Zoom oder vergrößertem Text',
      'espaciado-de-texto': 'Mit geändertem Textabstand',
      movil: 'Auf einem Mobilgerät oder mit schmalem Bildschirm',
      'colores-forzados': 'Mit erzwungenen Farben oder hohem Kontrast',
      'escala-de-grises': 'In Graustufen',
      'sin-estilos': 'Ohne Stile (ohne CSS)',
      'sin-sonido': 'Ohne Ton',
      'reducir-movimiento': 'Mit aktivierter Einstellung „Bewegung reduzieren“',
      voz: 'Mit Sprachsteuerung',
    },
    answerHint: {
      'sin-problemas':
        'Sie sind der Anleitung gefolgt, und alles, was passieren soll, passiert. Geprüft ist das, was Sie sich angesehen haben, nicht der Rest der Website.',
      problema:
        'Etwas, das passieren sollte, passiert nicht. Beschreiben Sie, was Sie gesehen haben: Es wird ein Problem angelegt.',
      'no-comprobado':
        'Sie konnten die Prüfung nicht durchführen (ein Werkzeug fehlte, eine Seite ließ sich nicht laden …). Es bleibt ungeprüft, das ist keine positive Antwort.',
      'no-aplica':
        'Die Seite hat nicht, was die Anleitung prüft (zum Beispiel gibt es keine Videos). Das muss begründet werden.',
    },
    help: {
      guiada: 'Geführte Prüfung',
      especializada: 'Kann Unterstützung durch Fachleute erfordern',
      none: 'Keine Anleitung verfügbar',
    },
    noGuide:
      'Für diesen Aspekt ist keine Anleitung verfügbar, daher lässt er sich von hier aus nicht Schritt für Schritt prüfen. Die Prüfung steht weiterhin aus.',
    needsNew: 'Neue Prüfung nötig',
    needsNewHint:
      'Die Seite hat sich geändert, seit sie geprüft wurde. Die frühere Bewertung bleibt bestehen, bis die Prüfung wiederholt wird.',
    row: {
      automatic: 'Automatische Analyse',
      manual: 'Manuelle Prüfung',
      pages_one: 'auf {{count}} Seite',
      pages_other: 'auf {{count}} Seiten',
      reviews_one: '{{count}} festgehaltene Prüfung',
      reviews_other: '{{count}} festgehaltene Prüfungen',
      drafts_one: '{{count}} Entwurf',
      drafts_other: '{{count}} Entwürfe',
      by: '{{name}}, {{date}}',
      someone: 'eine Person Ihrer Organisation',
    },
    actions: {
      start: 'Prüfung beginnen',
      resume: 'Prüfung fortsetzen',
      view: 'Prüfungen ansehen und wiederholen',
      repeat: 'Prüfung wiederholen',
      guide: 'Anleitung ansehen',
      back: 'Zurück zu den Ergebnissen',
    },
    page: {
      title: 'Manuelle Prüfung: {{id}} {{title}}',
      level: 'Stufe {{level}}',
      principle: '{{name}}',
      siteScope:
        'Diese Prüfung vergleicht mehrere Seiten, daher wird sie für die gesamte Website festgehalten und nicht für eine einzelne Seite.',
      noPages:
        'Es gibt noch keine analysierten Seiten, und diese Prüfung wird an einer Seite durchgeführt. Führen Sie eine Analyse durch und kommen Sie dann zurück.',
      loadFailed: 'Die Anleitung konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    },
    guide: {
      what: 'Was Sie prüfen werden',
      how: 'So gehen Sie vor',
      expected: 'Was passieren sollte',
      record: 'So halten Sie das Ergebnis fest',
      recordAnswers: 'Wählen Sie die passende Antwort:',
      specialist: 'Warum Unterstützung durch Fachleute nötig sein kann',
      version: 'Version der Anleitung: {{version}}.',
    },
    form: {
      title: 'Ihre Prüfung',
      identify: 'Was Sie prüfen',
      page: 'Seite',
      pageHelp: 'Die Seite, die Sie geprüft haben, aus den von SiteNorma analysierten.',
      pagePlaceholder: 'Seite auswählen',
      whole: 'Die gesamte Website',
      element: 'Element',
      elementHelp: 'Optional: der Teil der Seite, den Sie geprüft haben, zum Beispiel „Hauptmenü“.',
      device: 'Gerät',
      devices: {
        ambos: 'Desktop und Mobilgerät',
        escritorio: 'Desktop',
        movil: 'Mobilgerät',
      },
      conditions: 'Bedingungen der Prüfung',
      conditionsHelp: 'Markieren Sie, was Sie für die Prüfung verwendet haben.',
      conditionNotes: 'Weitere Bedingungen',
      conditionNotesHelp: 'Browser und Version, Screenreader, Fenstergröße …',
      answer: 'Ergebnis der Prüfung',
      answerHelp: 'Wenn Sie keine Antwort wählen, bleibt die Prüfung ausstehend.',
      description: 'Was Sie gefunden haben',
      descriptionHelp:
        'Pflichtfeld, wenn Sie ein Problem gefunden haben: was nicht funktioniert, wo und wie es sich bemerkbar macht.',
      reason: 'Warum Sie es nicht prüfen konnten',
      reasonHelp: 'Optional, hilft aber der Person, die es später übernimmt.',
      justification: 'Warum es nicht zutrifft',
      justificationHelp:
        'Pflichtfeld: Erklären Sie, warum diese Seite nicht hat, was geprüft wird (mindestens 20 Zeichen).',
      severity: 'Wie stark es die Nutzung der Website erschwert',
      severities: {
        grave: 'Es verhindert, dass eine Aufgabe abgeschlossen werden kann',
        moderada: 'Es erschwert die Aufgabe, sie lässt sich aber abschließen',
        leve: 'Es stört, hindert aber niemanden daran',
      },
      severityHelp:
        'Sie bestimmt die Priorität des Problems, wie bei den Problemen der automatischen Analyse.',
      evidence: 'Nachweise',
      evidenceHelp:
        'Was Sie gesehen haben, die verwendeten Werkzeuge und Versionen, ein Link zu einem Screenshot oder einer Aufnahme.',
      save: 'Entwurf speichern',
      saving: 'Wird gespeichert …',
      register: 'Prüfung festhalten',
      registering: 'Wird festgehalten …',
      discard: 'Entwurf verwerfen',
      discardConfirm: 'Den Entwurf verwerfen',
      discardBody:
        'Was Sie in diesem Entwurf geschrieben haben, wird gelöscht. Festgehaltene Prüfungen bleiben unberührt.',
      cancel: 'Abbrechen',
    },
    saved: {
      draft:
        'Entwurf gespeichert. Die Prüfung steht weiterhin aus: Es gibt noch keine festgehaltene Antwort.',
      registered:
        'Manuelle Prüfung festgehalten. Das bestätigt, dass sie gespeichert wurde; es bedeutet nicht, dass die Prüfung bestanden wurde.',
      discarded: 'Entwurf verworfen.',
    },
    errors: {
      respuesta: 'Wählen Sie eine Antwort, um die Prüfung festzuhalten, oder speichern Sie einen Entwurf.',
      pagina: 'Wählen Sie die Seite, die Sie geprüft haben.',
      descripcion: 'Beschreiben Sie das gefundene Problem (mindestens 10 Zeichen).',
      gravedad: 'Geben Sie an, wie stark es die Nutzung der Website erschwert.',
      justificacion: 'Erklären Sie, warum es nicht zutrifft (mindestens 20 Zeichen).',
      registrada:
        'Diese Prüfung ist bereits festgehalten und kann nicht geändert werden. Wiederholen Sie sie, um eine neue hinzuzufügen.',
      permiso: 'Ihre Rolle erlaubt es nicht, Prüfungen festzuhalten.',
      'sin-guia': 'Für diesen Aspekt gibt es keine Anleitung.',
      datos: 'Prüfen Sie die Angaben im Formular.',
      generic: 'Das Speichern war nicht möglich. Bitte versuchen Sie es erneut.',
    },
    drafts: {
      title: 'Ihre laufenden Entwürfe',
      intro: 'Machen Sie dort weiter, wo Sie aufgehört haben.',
      open: 'Diesen Entwurf fortsetzen',
      updated: 'Gespeichert am {{date}}',
      start: 'Neue Prüfung beginnen',
    },
    history: {
      title: 'Frühere Prüfungen',
      intro:
        'Alle bleiben erhalten, mit den befolgten Anweisungen und ihren Nachweisen: Eine neue Prüfung kommt zu den früheren hinzu und ersetzt sie nicht.',
      empty: 'Zu diesem Aspekt ist noch keine Prüfung festgehalten.',
      current: 'Aktuelle Bewertung',
      earlier: 'Früher',
      by: 'Festgehalten von {{name}}, {{date}}',
      page: 'Seite',
      element: 'Element',
      device: 'Gerät',
      conditions: 'Bedingungen',
      none: 'Nicht angegeben',
      description: 'Was gefunden wurde',
      reason: 'Warum nicht geprüft werden konnte',
      justification: 'Warum es nicht zutrifft',
      evidence: 'Nachweise',
      severity: 'Wie stark es erschwert',
      instructions: 'Befolgte Anweisungen (Version {{version}})',
      afterFix: 'Durchgeführt, um eine Korrektur zu prüfen',
      repeats: 'Wiederholt eine frühere Prüfung',
    },
    found: {
      origin: 'Bei einer manuellen Prüfung erkannt',
      from: 'Manuelle Prüfung des Kriteriums {{id}}',
      by: 'Geprüft von {{name}}, {{date}}',
      element: 'Element: {{element}}',
      device: 'Gerät: {{device}}',
      conditions: 'Bedingungen: {{list}}',
      evidence: 'Nachweise: {{text}}',
      open: 'Anleitung ansehen und Prüfung wiederholen',
      note: 'Dieses Problem stammt aus einer manuellen Prüfung: Es wird durch eine spätere Prüfung geschlossen, die das Problem nicht findet, nicht durch eine automatische Analyse.',
    },
    follow: {
      title: 'Geführte manuelle Prüfung',
      hint: 'Wenn die automatische Analyse nicht entscheiden kann, kann eine Person die Prüfung anhand der Anleitung wiederholen. Eine positive Prüfung, die alle Geräte abdeckt, auf denen das Problem erkannt wurde, erlaubt es, die Arbeit zu archivieren.',
      repeat: 'Die Anleitung „{{title}}“ wiederholen',
      repeatId: 'Die Anleitung des Kriteriums {{id}} wiederholen',
    },
    prepare: {
      title: 'Prüfungen, die eine Person erfordern',
      intro:
        'Bei diesen Elementen kann die automatische Analyse nicht allein entscheiden. Sie können die Prüfung mit der Anleitung wiederholen; die Analyse schließt sie nicht ab.',
      repeat: 'Anleitung {{id}} für {{element}} wiederholen',
    },
  },
  follow: {
    panel: {
      intro:
        'Der Status zeigt den Fortschritt der Korrektur. Um zu bestätigen, dass das Problem gelöst ist, muss es überprüft werden.',
      kinds: {
        'sin-comprobar': 'Nicht verifiziert',
        pendiente: 'Überprüfung ausstehend',
        verificado: 'Überprüft',
        persiste: 'Das Problem wird weiterhin erkannt',
        descartada: 'Erkennung verworfen',
      },
      sources: { automatica: 'Automatische Analyse', manual: 'Manuelle Prüfung' },
      on: '{{source}} · {{date}}',
      hints: {
        pendiente: 'Analysieren Sie die Seite erneut, um es zu prüfen.',
        persiste: 'Prüfen Sie die Korrektur und analysieren Sie die Seite erneut.',
        descartada: 'Diese Erkennung zählt nicht als Problem.',
      },
      manual: 'Die automatische Analyse kann diesen Fall nicht entscheiden. Eine manuelle Prüfung ist nötig.',
      recheck: 'Erneut analysieren',
      check: 'Korrektur prüfen',
      advanced: 'Erweiterte Optionen',
      advancedHint: 'Validierung, Verwerfen, manuelle Prüfung, Verlauf und Änderungen an mehreren Elementen',
      bulk: {
        title: 'Status auf die {{count}} Elemente anwenden',
        hint: 'Wählen Sie den Status, den Sie anwenden möchten.',
        choose: 'Status wählen',
        apply: 'Anwenden',
        confirmTitle: 'Status auf {{count}} Elemente anwenden?',
        confirmBody:
          'Der Arbeitsstatus von {{count}} Elementen wird geändert. Prüfergebnisse werden nicht verändert und jedes Element behält seinen eigenen Verlauf.',
        confirm: 'Status anwenden',
        cancel: 'Abbrechen',
        done: 'Status auf {{count}} Elemente angewendet.',
        label: 'Anzuwendender Status',
      },
    },
    quick: {
      work: 'Stand der Arbeit',
      verification: 'Verifizierung',
      more: 'Weitere Verfolgungsoptionen',
    },
    title: 'Status des Problems',
    save: 'Status speichern',
    saving: 'Wird gespeichert …',
    notice:
      'Den Status in SiteNorma zu ändern, verändert Ihre Website nicht. Nehmen Sie die Korrektur vor, bevor Sie sie prüfen.',
    readOnly: 'Ihre Rolle erlaubt es nur, den Status einzusehen.',
    saved: 'Status gespeichert.',
    savedMany_one:
      'Status bei {{count}} Element gespeichert, das seinen eigenen Verlauf behält. Es wurde keine Analyse gestartet und keine Seite verbraucht.',
    savedMany_other:
      'Status bei {{count}} Elementen gespeichert, jedes mit seinem eigenen Verlauf. Es wurde keine Analyse gestartet und keine Seite verbraucht.',
    errors: {
      justificacion: 'Um eine Erkennung zu verwerfen, erklären Sie, warum: mindestens 20 Zeichen.',
      evidencia: 'Um eine Erkennung zu verwerfen, geben Sie den Nachweis dafür an: mindestens 10 Zeichen.',
      permiso: 'Ihre Rolle erlaubt es nicht, den Status zu ändern.',
      'permiso-descartar':
        'Nur Personen mit der Rolle Inhaber oder Administrator können eine Erkennung verwerfen.',
      vacio: 'Wählen Sie vor dem Speichern aus, was Sie ändern möchten.',
      demasiados: 'Das sind zu viele Elemente auf einmal. Gehen Sie Problem für Problem vor.',
      generic: 'Der Status konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    },
    by: '{{name}}, {{date}}',
    someone: 'eine Person Ihrer Organisation',
    system: 'eine Analyse',
    noteLabel: 'Notiz',
    noteHint: 'Optional. Sie bleibt mit Ihrem Namen und dem Datum im Verlauf.',
    work: {
      title: 'Nachverfolgung der Arbeit',
      description: 'Was Ihr Team tut. Es sagt nicht, ob das Problem gelöst ist.',
      statuses: {
        pendiente: 'Noch zu beheben',
        'en-curso': 'In Arbeit',
        aplicada: 'Korrektur angewendet',
        aplazada: 'Zurückgestellt',
        archivada: 'Arbeit archiviert',
      },
      hints: {
        pendiente: 'Niemand hat begonnen, es zu beheben.',
        'en-curso': 'Jemand im Team arbeitet daran.',
        aplicada:
          'Sie haben die Website geändert. Die Prüfung steht noch aus: Nur eine Prüfung kann es bestätigen.',
        aplazada: 'Es wird später behoben. Das Problem bleibt in den Ergebnissen und in der Punktzahl.',
      },
      reopens: 'Die Wahl eines Status öffnet die archivierte Arbeit wieder.',
    },
    validation: {
      title: 'Validierung der Erkennung',
      description: 'Ob die Erkennung ein echtes Problem ist. Es sagt nicht, ob es behoben ist.',
      none: 'Automatische Erkennung, keine manuelle Validierung',
      statuses: {
        pendiente: 'Validierung ausstehend',
        confirmada: 'Erkennung bestätigt',
        descartada: 'Erkennung mit Begründung verworfen',
      },
      hints: {
        pendiente: 'Es muss von Hand geprüft werden, bevor entschieden wird, ob es ein Problem ist.',
        confirmada:
          'Eine Person hat geprüft, dass es ein echtes Problem ist. Das bedeutet nicht, dass es behoben ist.',
        descartada:
          'Es ist auf dieser Website kein echtes Problem. Es fällt aus den Zahlen und der Punktzahl heraus und wird mit Ihrer Begründung gesondert aufgelistet.',
        revert: 'Nimmt die frühere Entscheidung zurück und validiert die Erkennung erneut.',
      },
      keep: 'Keine Änderung',
      adminOnly:
        'Eine Erkennung zu verwerfen ändert die Zahlen und die Punktzahl: Das können nur Personen mit der Rolle Inhaber oder Administrator.',
      justification: 'Begründung',
      justificationHint: 'Warum es auf dieser Website kein Problem ist. Mindestens 20 Zeichen.',
      evidence: 'Nachweis',
      evidenceHint:
        'Was Sie geprüft haben: ein Test, ein Screenshot, ein Link oder ein Ergebnis. Mindestens 10 Zeichen.',
      discardNote:
        'Die ursprüngliche Erkennung und ihr Verlauf bleiben erhalten. Das Element fällt aus den Zahlen und der Punktzahl heraus und wird mit Ihrer Begründung, Ihrem Namen und dem Datum gesondert aufgelistet. Sie können das Verwerfen jederzeit aufheben.',
      decidedBy: 'Entschieden von {{name}}, {{date}}.',
      justificationLine: 'Begründung: {{text}}',
      evidenceLine: 'Nachweis: {{text}}',
    },
    check: {
      title: 'Ergebnis der letzten Prüfung',
      description: 'Was eine spätere Analyse oder eine manuelle Prüfung gefunden hat.',
      none: 'Nicht verifiziert',
      noneHint:
        'Keine Analyse und keine manuelle Prüfung hat dieses Element verifiziert, seit es erkannt wurde.',
      results: {
        'sigue-detectandose': 'Wird weiterhin erkannt',
        'no-detectado': 'Bei der letzten Prüfung nicht erkannt',
        'no-comprobable': 'Nicht automatisch bestätigt',
        'requiere-revision': 'Manuelle Prüfung erforderlich',
      },
      sources: {
        automatica: 'Automatische Analyse',
        manual: 'Manuelle Prüfung',
      },
      on: '{{source}} vom {{date}}',
      devices: 'Geräte: {{list}}.',
      stillPending:
        'Die Prüfung der Korrektur steht noch aus: Ein anderes Ergebnis als „Nicht erkannt“ bestätigt sie nicht.',
      reasons: {
        detectado: 'Die Analyse hat dieses Element erneut gefunden.',
        'detectado-en-revision':
          'Die Analyse hat es gefunden, kann aber nicht entscheiden, ob es ein Fehler ist: Es muss von Hand geprüft werden.',
        comprobado:
          'Eine vergleichbare Analyse hat die Seite geprüft und es nicht mehr erkannt. Das bedeutet nicht, dass die Website die Vorschriften einhält.',
        'revision-favorable': 'Eine Person hat es von Hand geprüft, und es wird erfüllt.',
        'revision-desfavorable': 'Eine Person hat es von Hand geprüft, und es wird weiterhin nicht erfüllt.',
        'pagina-fuera': 'Die Seite war nicht Teil dieser Analyse, daher konnte es nicht bestätigt werden.',
        'pagina-no-analizada':
          'Die Website hat die Analyse der Seite nicht zugelassen (blockiert, begrenzt oder mit Fehler): Wir wissen nicht, ob es behoben wurde.',
        dispositivo:
          'Die Analyse hat nicht alle Geräte abgedeckt, auf denen es erkannt wurde (Desktop und Mobilgerät): Sie ist nicht vergleichbar.',
        versiones:
          'Diese Analyse hat eine andere Version der Engine oder der Regeln verwendet und ist daher nicht mit der vergleichbar, die das Problem erkannt hat. Prüfen Sie es erneut.',
        'regla-no-aplicada':
          'Der Test hat auf der Seite kein Element dieser Art gefunden: Vielleicht haben Sie es entfernt oder verschoben. Prüfen Sie es von Hand.',
        muestra:
          'Der Test listet nur einen Teil der Elemente der Seite auf, und dieses gehört nicht dazu: Wir können nicht sicher sagen, dass es behoben ist.',
        'posible-cambio':
          'Dieses Element schlägt mit seinem ursprünglichen Selektor nicht mehr fehl, aber die Seite hat noch andere Fehler derselben Art. Es könnte dasselbe mit einer anderen Adresse im Code sein: die Analyse bestätigt es nicht allein. Prüfen Sie es von Hand.',
        'ventana-emergente':
          'Es befindet sich in einem Pop-up oder einem Hinweis, der bei der Analyse möglicherweise nicht erscheint. Prüfen Sie es von Hand.',
        'sin-registro':
          'Dieser Test hält die Elemente, die die Anforderung erfüllen, nicht fest: Es muss von Hand geprüft werden.',
        incierta:
          'Das ist ein Punkt, den automatische Tests nicht entscheiden können: Er muss von Hand geprüft werden.',
      },
    },
    verify: {
      action: 'Korrektur prüfen',
      hint: 'Öffnet die Übersicht vor der Analyse: Dort sehen Sie, welche Seiten geprüft werden und wie viele sie verbraucht. Die Analyse beginnt erst, wenn Sie die Analyse-Schaltfläche drücken.',
      many_one: 'Umgesetzte Korrektur prüfen',
      many_other: 'Die {{count}} umgesetzten Korrekturen prüfen',
    },
    review: {
      title: 'Manuelle Prüfung festhalten',
      hint: 'Nutzen Sie sie, wenn die Analyse es nicht entscheiden kann (ein Pop-up, ein Element, das seinen Platz gewechselt hat, ein zu prüfender Punkt) oder wenn Sie es lieber selbst prüfen. Folgen Sie den Schritten unter „So prüfen Sie es“.',
      outcome: 'Ergebnis der Prüfung',
      favorable: 'Wird erfüllt',
      favorableHint: 'Auf den Geräten, die Sie geprüft haben, ist es kein Problem mehr.',
      desfavorable: 'Wird weiterhin nicht erfüllt',
      desfavorableHint: 'Das Problem besteht weiterhin.',
      devices: 'Geräte, die Sie geprüft haben',
      devicesHint: 'Eine positive Prüfung muss alle Geräte abdecken, auf denen es erkannt wurde.',
      note: 'Was Sie getan und was Sie gesehen haben',
      noteHint: 'Mindestens 10 Zeichen. Der Text bleibt im Verlauf.',
      save: 'Prüfung festhalten',
      saved: 'Prüfung festgehalten.',
      errors: {
        ambito: 'Eine positive Prüfung muss alle Geräte abdecken, auf denen es erkannt wurde.',
        archivada:
          'Diese Arbeit ist archiviert: Öffnen Sie sie wieder, bevor Sie eine weitere Prüfung festhalten.',
        permiso: 'Ihre Rolle erlaubt es nicht, Prüfungen festzuhalten.',
        generic: 'Die Prüfung konnte nicht festgehalten werden. Bitte versuchen Sie es erneut.',
      },
    },
    archive: {
      title: 'Korrekturarbeit archivieren',
      evidence: 'Nachweis, der es begründet',
      evidenceAuto:
        'Eine vergleichbare Analyse vom {{date}} hat die Seite geprüft und dieses Element nicht mehr erkannt.',
      evidenceManual: 'Eine positive manuelle Prüfung vom {{date}}.',
      noteLabel: 'Notiz zur Archivierung',
      noteHint: 'Optional.',
      action: 'Korrekturarbeit archivieren',
      archiving: 'Wird archiviert …',
      done: 'Arbeit archiviert.',
      notCertification:
        'Archivieren bedeutet nicht, dass die Website die Vorschriften einhält: Es schließt die Arbeit an diesem Element mit dem Nachweis einer Prüfung ab. Wenn eine vergleichbare Prüfung es erneut erkennt, wird die Arbeit als ausstehend wieder geöffnet.',
      archivedBy: 'Arbeit am {{date}} von {{name}} archiviert.',
      why: {
        'sin-comprobacion':
          'Die Arbeit lässt sich archivieren, sobald eine vergleichbare Analyse das Problem nicht mehr erkennt oder eine positive manuelle Prüfung festgehalten wird.',
        'no-favorable':
          'Die Arbeit lässt sich noch nicht archivieren: Die letzte Prüfung ist nicht positiv. Archivieren ist nach einer Prüfung möglich, die es nicht erkennt, oder nach einer positiven manuellen Prüfung.',
        'anterior-a-la-correccion':
          'Die letzte positive Prüfung liegt vor der Korrektur, die Sie als umgesetzt markiert haben. Prüfen Sie sie erneut.',
        'ya-archivada': 'Die Arbeit ist bereits archiviert.',
      },
      errors: {
        'sin-evidencia':
          'Es gibt keine Prüfung mehr, die das Archivieren begründet. Sehen Sie sich das Ergebnis an.',
        permiso: 'Ihre Rolle erlaubt es nicht zu archivieren.',
        generic: 'Das Archivieren war nicht möglich. Bitte versuchen Sie es erneut.',
      },
    },
    history: {
      title: 'Verlauf',
      loading: 'Verlauf wird geladen …',
      empty: 'Im Verlauf steht noch nichts.',
      error: 'Der Verlauf konnte nicht geladen werden.',
      note: 'Notiz: {{text}}',
      created: 'Die Nachverfolgung dieses Elements wurde begonnen.',
      createdMigrated:
        'Eine frühere Entscheidung über die Gruppe, zu der dieses Element gehörte, bleibt erhalten ({{from}}).',
      work: 'Nachverfolgung der Arbeit: von „{{from}}“ zu „{{to}}“.',
      validation: 'Validierung der Erkennung: von „{{from}}“ zu „{{to}}“.',
      lifted:
        'Ein Verwerfen mit der Begründung „{{justification}}“ (Nachweis: „{{evidence}}“) wurde aufgehoben.',
      check: 'Automatische Prüfung: {{result}}. {{reason}}',
      review: 'Manuelle Prüfung ({{outcome}}) auf {{devices}}: {{text}}',
      guided: 'Geführte Prüfung des Kriteriums {{criterion}}: {{outcome}}. Geräte: {{devices}}. {{text}}',
      archive: 'Korrekturarbeit archiviert.',
      reopenManual: 'Archivierte Arbeit durch die Wahl eines Status wieder geöffnet.',
      reopenAuto: 'Arbeit als ausstehend wieder geöffnet: Eine Prüfung hat es erneut erkannt.',
      none: 'keine Entscheidung',
      actor: '{{name}}, {{date}}',
    },
    summary: {
      figures: {
        tracked: 'Verfolgte Elemente',
        applied: 'Korrektur angewendet',
        verified: 'Durch Prüfung verifiziert',
      },
      title: 'Nachverfolgung der Arbeit und Entscheidungen',
      intro:
        'Drei verschiedene Zahlen: wie viele Elemente Ihr Team verfolgt, bei wie vielen die Korrektur gemeldet ist und bei wie vielen eine Prüfung sie nicht mehr erkennt. „Korrektur angewendet“ verifiziert sie nicht: Sie müssen sie prüfen.',
      none: 'Ihr Team hat zu den Elementen dieser Website noch nichts festgehalten.',
      tracked_one: '{{count}} Element in Nachverfolgung',
      tracked_other: '{{count}} Elemente in Nachverfolgung',
      discarded_one:
        '{{count}} Erkennung mit Begründung verworfen: Sie zählt weder in den Zahlen noch in der Punktzahl.',
      discarded_other:
        '{{count}} Erkennungen mit Begründung verworfen: Sie zählen weder in den Zahlen noch in der Punktzahl.',
      open: 'Nachverfolgung öffnen',
    },
    tab: {
      name: 'Nachverfolgung',
      title: 'Nachverfolgung der Korrekturen',
      intro:
        'Der Arbeitsstatus (zum Beispiel „Korrektur angewendet“), das Prüfungsergebnis und die Verwürfe. Die Korrektur zu melden verifiziert sie nicht: Sie müssen sie prüfen.',
      viewProblems: 'Probleme ansehen',
      loadFailed: 'Die Nachverfolgung konnte nicht geladen werden.',
      empty:
        'Noch keine Korrekturen erfasst. Beginnen Sie bei den erkannten Problemen und erfassen Sie den Status eines Elements.',
      filters: 'Filter',
      work: 'Nachverfolgung der Arbeit',
      check: 'Ergebnis der Prüfung',
      all: 'Alle',
      shown_one: '{{shown}} von {{total}} Element wird angezeigt.',
      shown_other: '{{shown}} von {{total}} Elementen werden angezeigt.',
      none: 'Kein Element passt zu den Filtern.',
      element: 'Element',
      problem: 'Problem',
      page: 'Seite',
      states: 'Status',
      open: 'Element ansehen',
      openPage: 'Seite ansehen',
      noCapture: 'Es ist in der letzten Analyse nicht mehr enthalten.',
      checkAll: 'Umgesetzte Korrekturen prüfen',
      checkAllHint_one:
        'Die als umgesetzt markierte Korrektur wird über die Übersicht vor der Analyse geprüft.',
      checkAllHint_other:
        'Die {{count}} als umgesetzt markierten Korrekturen werden über die Übersicht vor der Analyse geprüft.',
      checkTooMany:
        'Es gibt umgesetzte Korrekturen auf mehr als {{max}} Seiten: Sie werden in Teilen geprüft. Öffnen Sie jede in ihrer Detailansicht.',
      discards: 'Mit Begründung verworfene Erkennungen',
      discardsIntro:
        'Sie fallen aus den Zahlen und der Punktzahl heraus. Die ursprüngliche Erkennung und ihr Verlauf bleiben erhalten.',
      discardedBy: 'Verworfen von {{name}}, {{date}}.',
      lift: 'Um ein Verwerfen aufzuheben, öffnen Sie das Element.',
      manage: 'Status verwalten',
      showArchived: 'Archivierte Arbeit anzeigen',
    },
    problem: {
      title: 'Status des Problems',
      counts_one: '{{count}} Element von {{total}} in Nachverfolgung',
      counts_other: '{{count}} Elemente von {{total}} in Nachverfolgung',
      bulkTitle: 'Denselben Status auf alle Elemente anwenden',
      bulkHint:
        'Er wird bei jedem Element separat mit eigenem Verlauf gespeichert. Nutzen Sie das, wenn der Status für alle gleich ist.',
      bulkApplies_one: 'Er wird auf {{count}} Element dieses Problems angewendet.',
      bulkApplies_other: 'Er wird auf alle {{count}} Elemente dieses Problems angewendet.',
      discardedElements_one: '{{count}} Element mit Begründung verworfen',
      discardedElements_other: '{{count}} Elemente mit Begründung verworfen',
      allDiscarded:
        'Alle Elemente dieses Problems sind mit Begründung verworfen: Es zählt weder in den Zahlen noch in der Punktzahl.',
    },
    discardedList: {
      title: 'Mit Begründung verworfene Probleme',
      intro:
        'Alle ihre Elemente sind verworfen, daher zählen sie weder in den Gesamtzahlen noch in der Punktzahl. Öffnen Sie eines, um die Begründung zu sehen oder das Verwerfen aufzuheben.',
    },
  },
  site: {
    created: 'Website hinzugefügt. Die Analyse wurde noch nicht gestartet.',
    back: 'Ihre Websites',
    address: 'Adresse',
    profile: 'Regelwerk',
    tabs: {
      pages: 'Seiten',
      follow: 'Nachverfolgung',
    },
    details: 'Details der Website',
    analysisStandard: 'In der Analyse verwendeter Standard',
    harmonised: 'Aktuelle harmonisierte europäische Referenz',
    standardsNote:
      'Die harmonisierte Referenz ist die Fassung, die das Amtsblatt der Europäischen Union heute zitiert (Beschluss (EU) 2021/1339). Der Standard der Analyse hängt vom Regelwerk der Website ab.',
    verificationLink: 'zur Verifizierung der Inhaberschaft',
    verifyAction: 'Inhaberschaft verifizieren',
    notFound: 'Diese Website existiert nicht oder gehört nicht zu Ihrer Organisation.',
    verification: {
      steps: {
        choose: 'Methode wählen',
        publish: 'Code veröffentlichen',
        check: 'Prüfen',
        done: 'fertig',
      },
      title: 'Verifizierung der Inhaberschaft',
      intro: 'Die Verifizierung zeigt, dass die Website Ihnen gehört.',
      without: 'Nicht verifiziert: Einzelseiten-Analyse und Schnellanalyse (3 Seiten).',
      with: 'Mit verifiziertem Eigentum: vollständige Analyse (bis zu 50 Seiten), die nicht von der robots.txt abhängt.',
      verified: 'Inhaberschaft am {{date}} verifiziert ({{method}}).',
      readOnly: 'Bitten Sie eine Person mit der Rolle Editor oder höher, sie zu verifizieren.',
      method: 'Wie möchten Sie sie verifizieren?',
      methods: {
        meta: 'Meta-Tag',
        dns: 'DNS-Eintrag',
        fichero: 'Datei',
      },
      methodHints: {
        meta: 'Am schnellsten, wenn Sie den Code der Startseite bearbeiten können.',
        dns: 'Für alle, die die Domain verwalten; funktioniert auch, wenn eine Firewall die Website blockiert. Kann einige Stunden dauern.',
        fichero: 'Wenn Sie Dateien auf den Server der Website hochladen können.',
      },
      metaSteps:
        'Fügen Sie dieses Tag in <head> auf {{url}} ein, veröffentlichen Sie die Änderung und klicken Sie auf „Jetzt prüfen“:',
      dnsSteps:
        'Legen Sie im DNS Ihrer Domain einen TXT-Eintrag mit dem Namen {{host}} und diesem Wert an und klicken Sie auf „Jetzt prüfen“:',
      dnsNote: 'DNS-Änderungen können einige Stunden dauern, bis sie sichtbar sind.',
      fileSteps:
        'Erstellen Sie eine unter {{url}} erreichbare Textdatei mit diesem Inhalt und klicken Sie auf „Jetzt prüfen“:',
      tag: 'Tag',
      record: 'Wert des TXT-Eintrags',
      fileContent: 'Inhalt der Datei',
      copy: 'Kopieren',
      copied: 'Kopiert',
      check: 'Jetzt prüfen',
      checking: 'Verifizierung wird geprüft …',
      checkingHint:
        'Wir prüfen den Code auf Ihrer Website. Sie können diesen Bildschirm verlassen; das Ergebnis erscheint hier.',
      checkingWait:
        'Die Prüfung läuft noch. Wenn die Website langsam antwortet, kann es noch einige Sekunden dauern.',
      checkingSlow:
        'Es sind mehr als 15 Sekunden vergangen. Wenn die Website nicht antwortet, schlägt die Prüfung fehl und Sie können eine andere Methode versuchen.',
      done: 'Fertig: Wir haben die Inhaberschaft der Website verifiziert.',
      errors: {
        'meta-missing':
          'Wir finden das Tag auf {{url}} nicht. Prüfen Sie, ob es innerhalb von <head> steht und die veröffentlichte Seite es schon enthält.',
        'file-missing': 'Die Datei existiert, enthält aber den Code nicht. Prüfen Sie ihren Inhalt.',
        'dns-missing':
          'Wir sehen den TXT-Eintrag noch nicht. DNS-Änderungen können einige Stunden dauern: Versuchen Sie es später erneut.',
        http: 'Wir konnten die Verifizierung nicht abschließen, weil die Website einen HTTP-Fehler {{status}} zurückgegeben hat. Prüfen Sie, ob die Adresse stimmt und die Seite erreichbar ist. Sie können auch eine andere Verifizierungsmethode versuchen, zum Beispiel den DNS-Eintrag.',
        unreachable:
          'Wir konnten die Verifizierung nicht abschließen, weil wir die Website nicht erreichen konnten. Prüfen Sie, ob die Adresse stimmt und die Website erreichbar ist. Sie können auch eine andere Verifizierungsmethode versuchen, zum Beispiel den DNS-Eintrag.',
        timeout: 'Die Prüfung wurde nicht abgeschlossen. Versuchen Sie es gleich noch einmal.',
        limite:
          'Sie haben in kurzer Zeit viele Prüfungen durchgeführt. Warten Sie eine Weile und versuchen Sie es erneut.',
      },
    },
    settings: {
      title: 'Einstellungen',
      scope:
        'Diese Einstellungen betreffen nur diese Website. Ihre persönlichen Daten und Ihr Passwort finden Sie unter <profile>Mein Profil</profile> und <security>Sicherheit</security>.',
      profileUnset:
        'Sie haben noch kein regulatorisches Profil gewählt. Wählen Sie es hier oder beim Vorbereiten einer Analyse. Bis dahin verwendet die Analyse WCAG 2.2 Stufe AA als technische Referenz.',
      name: 'Name',
      save: 'Änderungen speichern',
      saved: 'Änderungen gespeichert.',
      profileNote:
        'Das Profil gibt nur an, welche Vorschrift bei der Analyse als Referenz dient. Die Auswahl bescheinigt oder belegt nicht, dass Ihre Website das Gesetz erfüllt, und entscheidet auch nicht, ob es für Sie gilt: Das hängt von Ihrer Tätigkeit ab.', // claims-ok
      cardImage: {
        title: 'Vorschaubild',
        intro:
          'Aktualisieren Sie den Screenshot der Startseite und das Symbol, die auf der Karte dieser Website unter «Ihre Websites» erscheinen.\n\nDiese Aktion startet keine Analyse und verbraucht keine Seiten Ihres Tarifs. Das Bild kann sich auch aktualisieren, wenn Sie eine neue Analyse der Startseite durchführen.',
        action: 'Vorschau aktualisieren',
        working: 'Wird aktualisiert…',
        done: 'Das neue Bild wird aufgenommen. Es erscheint in wenigen Sekunden unter «Ihre Websites».',
        errors: {
          permiso: 'Ihre Rolle erlaubt keine Aktualisierung des Bildes dieser Website.',
          limite:
            'Sie haben das Bild zu oft aktualisieren lassen. Warten Sie einen Moment und versuchen Sie es erneut.',
          generic: 'Das Bild konnte nicht aktualisiert werden. Versuchen Sie es erneut.',
        },
      },
      errors: {
        permiso:
          'Ihre Rolle erlaubt keine Änderung der Einstellungen dieser Website. Nichts wurde gespeichert.',
        gone: 'Diese Website existiert nicht mehr. Nichts wurde gespeichert.',
        generic: 'Die Änderungen konnten nicht gespeichert werden. Versuchen Sie es erneut.',
      },
    },
    remove: {
      title: 'Website löschen',
      intro: 'Die Website und alle ihre Daten werden gelöscht. Das lässt sich nicht rückgängig machen.',
      dataTitle: 'Gelöscht werden:',
      data: {
        analyses: 'Die Analysen und ihre Ergebnisse.',
        follow: 'Die Verfolgung der Korrekturen mit Verlauf.',
        reviews: 'Die erfassten manuellen Prüfungen.',
        ownership: 'Die Eigentumsverifizierung und gegebenenfalls die WordPress-Verknüpfung.',
      },
      typeName: 'Geben Sie „{{name}}“ zur Bestätigung ein',
      button: 'Website löschen',
      confirmTitle: '{{name}} löschen?',
      confirm: 'Löschen',
      cancel: 'Abbrechen',
    },
  },
  invitation: {
    title: 'Einladung zu einer Organisation',
    details: '{{inviter}} lädt Sie zu {{organization}} mit der Rolle {{role}} ein.',
    accept: 'Einladung annehmen',
    acceptedTitle: 'Einladung angenommen',
    accepted: 'Sie gehören jetzt zur Organisation.',
    continue: 'Zum Dashboard',
    loginFirst:
      'Um sie anzunehmen, melden Sie sich an oder erstellen Sie ein Konto mit der E-Mail-Adresse, an die die Einladung geschickt wurde.',
    login: 'Anmelden',
    signup: 'Konto erstellen',
    invalid:
      'Die Einladung ist ungültig, abgelaufen oder für eine andere E-Mail-Adresse. Melden Sie sich mit dem Konto an, an das sie geschickt wurde, oder bitten Sie um eine neue.',
  },
};
